var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArduinoMegaIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "193px",
    height: "95px",
    viewBox: "0 0 193 95",
    style: {
      enableBackground: "new 0 0 193 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F7391;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.6193;stroke-linecap:round;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#333333;}\r\n\t.st4{fill:none;stroke:#9A916C;stroke-width:0.4379;}\r\n\t.st5{fill:#9A916C;}\r\n\t.st6{fill:none;stroke:#9A916C;stroke-width:0.5557;}\r\n\t.st7{fill:#404040;}\r\n\t.st8{fill:#2A2A29;}\r\n\t.st9{fill:#474747;}\r\n\t.st10{fill:#595959;}\r\n\t.st11{fill:#373737;}\r\n\t.st12{fill:#999999;}\r\n\t.st13{opacity:0.2;fill:#FFFFFF;}\r\n\t.st14{fill:#303030;}\r\n\t.st15{fill:#1F1F1F;}\r\n\t.st16{fill:#3D3D3D;}\r\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:#1F1F1F;}\r\n\t.st18{fill:#8D8C8C;}\r\n\t.st19{fill:#8D8455;}\r\n\t.st20{fill:#8C8663;}\r\n\t.st21{fill:#B8AF82;}\r\n\t.st22{fill:#80795B;}\r\n\t.st23{fill:#5E5B43;}\r\n\t.st24{fill:#CCCCCC;}\r\n\t.st25{opacity:0.102;}\r\n\t.st26{fill:#1A1A1A;}\r\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\r\n\t.st28{opacity:0.102;fill:#FFFFFF;}\r\n\t.st29{fill:#E6E6E6;}\r\n\t.st30{opacity:0.302;fill:#FFFFFF;}\r\n\t.st31{opacity:0.502;fill:#FFFFFF;}\r\n\t.st32{opacity:0.2;}\r\n\t.st33{fill:#232323;}\r\n\t.st34{fill:#494949;}\r\n\t.st35{opacity:0.302;fill:#3D3D3D;}\r\n\t.st36{opacity:0.4;fill:#0F0F0F;}\r\n\t.st37{opacity:0.502;}\r\n\t.st38{opacity:0.251;}\r\n\t.st39{opacity:0.251;fill:#565656;}\r\n\t.st40{fill:#6D6D6D;}\r\n\t.st41{fill:#808080;}\r\n\t.st42{fill:#B3B3B3;}\r\n\t.st43{opacity:0.502;fill:#CCCCCC;}\r\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:#641D1C;}\r\n\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:#852725;}\r\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17784_",
    className: "st0",
    d: "M182.7,81.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,80.6,182.7,81,182.7,81.4z M178.1,81.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,80.6,178.1,81,178.1,81.4z M182.7,76.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C183,76.1,182.7,76.4,182.7,76.9z M178.1,76.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C178.5,76.1,178.1,76.4,178.1,76.9z M182.7,72.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,71.5,182.7,71.9,182.7,72.4z M178.1,72.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,71.5,178.1,71.9,178.1,72.4z M182.7,67.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,67,182.7,67.4,182.7,67.9z M178.1,67.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,67,178.1,67.4,178.1,67.9z M182.7,63.3c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,62.5,182.7,62.9,182.7,63.3z M178.1,63.3c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,62.5,178.1,62.9,178.1,63.3z M182.7,58.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8S184,58,183.5,58 C183,58,182.7,58.3,182.7,58.8z M178.1,58.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8S179.5,58,179,58 C178.5,58,178.1,58.3,178.1,58.8z M182.7,54.3c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C183,53.4,182.7,53.8,182.7,54.3z M178.1,54.3c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C178.5,53.4,178.1,53.8,178.1,54.3z M182.7,49.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,48.9,182.7,49.3,182.7,49.8z M178.1,49.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,48.9,178.1,49.3,178.1,49.8z M182.7,45.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,44.4,182.7,44.8,182.7,45.2z M178.1,45.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,44.4,178.1,44.8,178.1,45.2z M182.7,40.7c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C183,39.9,182.7,40.2,182.7,40.7z M178.1,40.7c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C178.5,39.9,178.1,40.2,178.1,40.7z M182.7,36.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,35.3,182.7,35.7,182.7,36.2z M178.1,36.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,35.3,178.1,35.7,178.1,36.2z M182.7,31.7c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,30.8,182.7,31.2,182.7,31.7z M178.1,31.7c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,30.8,178.1,31.2,178.1,31.7z M182.7,27.1c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C183,26.3,182.7,26.7,182.7,27.1z M178.1,27.1c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8 C178.5,26.3,178.1,26.7,178.1,27.1z M182.7,22.6c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,21.8,182.7,22.2,182.7,22.6z M178.1,22.6c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,21.8,178.1,22.2,178.1,22.6z M182.7,18.1c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,17.2,182.7,17.6,182.7,18.1z M178.1,18.1c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,17.2,178.1,17.6,178.1,18.1z M182.7,13.6c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,12.7,182.7,13.1,182.7,13.6z M178.1,13.6c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,12.7,178.1,13.1,178.1,13.6z M182.7,9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,8.2,182.7,8.6,182.7,9z M178.1,9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,8.2,178.1,8.6,178.1,9z M182.7,4.5c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C183,3.7,182.7,4.1,182.7,4.5z M178.1,4.5c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 C178.5,3.7,178.1,4.1,178.1,4.5z M92.3,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C92.6,3.8,92.3,4.1,92.3,4.5C92.3,4.5,92.3,4.5,92.3,4.5z M96.8,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C97.1,3.8,96.8,4.1,96.8,4.5C96.8,4.5,96.8,4.5,96.8,4.5z M101.3,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C101.7,3.8,101.3,4.1,101.3,4.5C101.3,4.5,101.3,4.5,101.3,4.5z  M105.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C106.2,3.8,105.9,4.1,105.9,4.5 C105.9,4.5,105.9,4.5,105.9,4.5z M110.4,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C110.7,3.8,110.4,4.1,110.4,4.5C110.4,4.5,110.4,4.5,110.4,4.5z M114.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C115.2,3.8,114.9,4.1,114.9,4.5C114.9,4.5,114.9,4.5,114.9,4.5z M119.4,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C119.8,3.8,119.4,4.1,119.4,4.5 C119.4,4.5,119.4,4.5,119.4,4.5z M123.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C124.3,3.8,123.9,4.1,123.9,4.5C123.9,4.5,123.9,4.5,123.9,4.5z M92.3,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C92.6,89.7,92.3,90.1,92.3,90.5C92.3,90.5,92.3,90.5,92.3,90.5z M87.8,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C88.1,89.7,87.8,90.1,87.8,90.5 C87.8,90.5,87.8,90.5,87.8,90.5z M83.2,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C83.6,89.7,83.2,90.1,83.2,90.5C83.2,90.5,83.2,90.5,83.2,90.5z M78.7,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C79.1,89.7,78.7,90.1,78.7,90.5C78.7,90.5,78.7,90.5,78.7,90.5z M74.2,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C74.5,89.7,74.2,90.1,74.2,90.5 C74.2,90.5,74.2,90.5,74.2,90.5z M69.7,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C70,89.7,69.7,90.1,69.7,90.5C69.7,90.5,69.7,90.5,69.7,90.5z M65.1,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C65.5,89.7,65.1,90.1,65.1,90.5C65.1,90.5,65.1,90.5,65.1,90.5z M60.6,90.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C61,89.7,60.6,90.1,60.6,90.5C60.6,90.5,60.6,90.5,60.6,90.5z M85,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C85.4,3.8,85,4.1,85,4.5C85,4.5,85,4.5,85,4.5z  M80.5,4.5c0,0.4,0.3,0.8,0.8,0.8S82,4.9,82,4.5c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C80.9,3.8,80.5,4.1,80.5,4.5 C80.5,4.5,80.5,4.5,80.5,4.5z M76,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C76.3,3.8,76,4.1,76,4.5C76,4.5,76,4.5,76,4.5z M71.5,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C71.8,3.8,71.5,4.1,71.5,4.5C71.5,4.5,71.5,4.5,71.5,4.5z M66.9,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C67.3,3.8,66.9,4.1,66.9,4.5C66.9,4.5,66.9,4.5,66.9,4.5z M62.4,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C62.8,3.8,62.4,4.1,62.4,4.5 C62.4,4.5,62.4,4.5,62.4,4.5z M57.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C58.2,3.8,57.9,4.1,57.9,4.5C57.9,4.5,57.9,4.5,57.9,4.5z M53.4,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C53.7,3.8,53.4,4.1,53.4,4.5C53.4,4.5,53.4,4.5,53.4,4.5z M48.9,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C49.2,3.8,48.9,4.1,48.9,4.5C48.9,4.5,48.9,4.5,48.9,4.5z M44.3,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C44.7,3.8,44.3,4.1,44.3,4.5 C44.3,4.5,44.3,4.5,44.3,4.5z M133,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C133.3,3.8,133,4.1,133,4.5C133,4.5,133,4.5,133,4.5z M137.5,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C137.9,3.8,137.5,4.1,137.5,4.5C137.5,4.5,137.5,4.5,137.5,4.5z M142,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C142.4,3.8,142,4.1,142,4.5C142,4.5,142,4.5,142,4.5z M146.6,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C146.9,3.8,146.6,4.1,146.6,4.5 C146.6,4.5,146.6,4.5,146.6,4.5z M151.1,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C151.4,3.8,151.1,4.1,151.1,4.5C151.1,4.5,151.1,4.5,151.1,4.5z M155.6,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C156,3.8,155.6,4.1,155.6,4.5C155.6,4.5,155.6,4.5,155.6,4.5z M160.1,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C160.5,3.8,160.1,4.1,160.1,4.5C160.1,4.5,160.1,4.5,160.1,4.5z  M164.7,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C165,3.8,164.7,4.1,164.7,4.5 C164.7,4.5,164.7,4.5,164.7,4.5z M133,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C133.3,89.7,133,90.1,133,90.5C133,90.5,133,90.5,133,90.5z M128.5,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C128.8,89.7,128.5,90.1,128.5,90.5C128.5,90.5,128.5,90.5,128.5,90.5z M123.9,90.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C124.3,89.7,123.9,90.1,123.9,90.5C123.9,90.5,123.9,90.5,123.9,90.5z  M119.4,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C119.8,89.7,119.4,90.1,119.4,90.5 C119.4,90.5,119.4,90.5,119.4,90.5z M114.9,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C115.2,89.7,114.9,90.1,114.9,90.5C114.9,90.5,114.9,90.5,114.9,90.5z M110.4,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C110.7,89.7,110.4,90.1,110.4,90.5C110.4,90.5,110.4,90.5,110.4,90.5z M105.9,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C106.2,89.7,105.9,90.1,105.9,90.5 C105.9,90.5,105.9,90.5,105.9,90.5z M101.3,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C101.7,89.7,101.3,90.1,101.3,90.5C101.3,90.5,101.3,90.5,101.3,90.5z M173.7,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C174.1,89.7,173.7,90.1,173.7,90.5C173.7,90.5,173.7,90.5,173.7,90.5z M169.2,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C169.5,89.7,169.2,90.1,169.2,90.5 C169.2,90.5,169.2,90.5,169.2,90.5z M164.7,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C165,89.7,164.7,90.1,164.7,90.5C164.7,90.5,164.7,90.5,164.7,90.5z M160.1,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C160.5,89.7,160.1,90.1,160.1,90.5C160.1,90.5,160.1,90.5,160.1,90.5z M155.6,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C156,89.7,155.6,90.1,155.6,90.5 C155.6,90.5,155.6,90.5,155.6,90.5z M151.1,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C151.4,89.7,151.1,90.1,151.1,90.5C151.1,90.5,151.1,90.5,151.1,90.5z M146.6,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C146.9,89.7,146.6,90.1,146.6,90.5C146.6,90.5,146.6,90.5,146.6,90.5z M142,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C142.4,89.7,142,90.1,142,90.5 C142,90.5,142,90.5,142,90.5z M126.4,81.4c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9 C127.7,78.6,126.4,79.8,126.4,81.4C126.4,81.4,126.4,81.4,126.4,81.4z M126.4,31.7c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8 c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9C127.7,28.8,126.4,30.1,126.4,31.7C126.4,31.7,126.4,31.7,126.4,31.7z M33.6,90.5 c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9C34.9,87.6,33.6,88.9,33.6,90.5 C33.6,90.5,33.6,90.5,33.6,90.5z M169.4,4.5c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.9-2.8-2.9 C170.6,1.7,169.4,2.9,169.4,4.5z M35.9,4.5c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9 C37.2,1.7,35.9,2.9,35.9,4.5C35.9,4.5,35.9,4.5,35.9,4.5z M180.7,90.5c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8 c0-1.6-1.3-2.9-2.8-2.9C181.9,87.6,180.7,88.9,180.7,90.5z M183.5,0l4.5,4.5v18.1l4.5,4.5v61.1l-4.5,4.5v0.5c0,1-0.8,1.8-1.8,1.8 H13.4c-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0V1.8c0-1,0.8-1.8,1.8-1.8H183.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_17766_",
    className: "st1",
    points: "77.3,76.7 158.3,76.7 160.2,78.3 169.5,78.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_17762_",
    className: "st1",
    points: "169.1,74.1 169.1,26.8 171.2,25 171.2,12.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8412_",
    className: "st2",
    d: "M152.9,56.3h1.9l-1-3.2L152.9,56.3z M150.9,58.8l2.4-8.1c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.1,0.3-0.1s0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.3l2.3,8.1c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-0.5-1.6h-2.6l-0.5,1.6c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.4,0.1 c-0.2,0-0.3-0.1-0.4-0.2C151,59.1,150.9,59,150.9,58.8z M142.6,57.6v-3.2c0-0.5,0.2-1,0.5-1.4l1.6-2c0.3-0.4,0.8-0.7,1.4-0.7h1.7 c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2H146c-0.2,0-0.3,0.1-0.5,0.2 l-1.6,2c-0.2,0.2-0.2,0.5-0.2,0.7v3.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2h2.3c0.2,0,0.3-0.1,0.4-0.2 c0.1-0.1,0.2-0.3,0.2-0.4v-1.2H146c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.4-0.2h2.3v2.4c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.2,0.5h-2.3c-0.5,0-0.9-0.2-1.2-0.5 C142.8,58.5,142.6,58.1,142.6,57.6z M134.2,59.4v-9.1h5.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2h-4v2.8h1.7c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2h-1.7v2.8h4c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2H134.2z M125.8,58.8v-8.5h1.5l1.4,2l1.4-2h1.5v8.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4V52l-1.1,1.6v0.3c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4v-0.3L127,52v6.8c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2 c-0.2,0-0.3-0.1-0.4-0.2C125.9,59.1,125.8,59,125.8,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8392_",
    className: "st2",
    d: "M152.8,56.2l0.9-3.2l0.1-0.2l0.1,0.2l1,3.2l0,0.1h-0.1L152.8,56.2L152.8,56.2L152.8,56.2z  M152.9,56.2h1.9v0.1l-0.1,0l-1-3.2l0.1,0l0.1,0L152.9,56.2L152.9,56.2L152.9,56.2z M151,58.8c0,0.2,0.1,0.3,0.2,0.4 c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3l0.1,0l-0.1,0l0.5-1.6l0,0h0h2.6h0l0,0l0.5,1.6l-0.1,0l0.1,0 c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4h0.1l-0.1,0l-2.3-8.1l0,0l0,0 c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.2,0.3l-0.1,0l0.1,0L151,58.8L151,58.8 L151,58.8z M150.9,58.8l2.4-8.1l0,0l0,0c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1 c0.1,0.1,0.2,0.2,0.2,0.3l-0.1,0l0.1,0l2.3,8.1l0,0v0c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4-0.1 c-0.1-0.1-0.2-0.2-0.2-0.3l0,0l0,0l-0.5-1.6l0.1,0v0.1h-2.6v-0.1l0.1,0l-0.5,1.6l0,0l0,0c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3-0.1-0.5-0.2C150.9,59.2,150.9,59,150.9,58.8L150.9,58.8L150.9,58.8z M142.6,57.6 c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5h2.3c0.5,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.2v-2.4h0.1v0.1H146 c-0.2,0-0.3,0-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2h1.2h0.1v0.1v1.2 c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-2.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5v-3.2 c0-0.3,0.1-0.5,0.3-0.8l0,0l0,0l1.6-2l0,0l0,0c0.1-0.2,0.3-0.3,0.5-0.3h1.7c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4 c0-0.1,0-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2H146c-0.6,0-1,0.2-1.3,0.7l0,0l0,0l-1.6,2l0,0l0,0c-0.3,0.4-0.5,0.9-0.5,1.4V57.6z  M142.5,57.6v-3.2c0-0.5,0.2-1,0.5-1.5l0,0l0,0l1.6-2h0v0c0.4-0.5,0.8-0.7,1.4-0.7h1.7c0.2,0,0.3,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H146c-0.2,0-0.3,0.1-0.4,0.2l0,0l0,0l-1.6,2l0,0l0,0 c-0.2,0.2-0.2,0.4-0.2,0.7v3.2c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2h2.3c0.1,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4v-1.2 h0.1v0.1H146c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h2.3h0.1v0.1v2.4 c0,0.5-0.2,0.9-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5h-2.3c-0.5,0-0.9-0.2-1.3-0.5C142.7,58.6,142.5,58.1,142.5,57.6z M134.2,59.4h5.2 c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2h-4h-0.1v-0.1v-2.8v-0.1h0.1h1.7 c0.1,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2,0-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2h-1.7h-0.1v-0.1v-2.8v-0.1h0.1h4 c0.2,0,0.3,0,0.4-0.2s0.2-0.2,0.2-0.4c0-0.1,0-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2h-5.2v-0.1h0.1L134.2,59.4L134.2,59.4 L134.2,59.4z M134.2,59.4v-9.1v-0.1h0.1h5.2c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.3,0.2-0.5,0.2h-4v-0.1h0.1v2.8h-0.1v-0.1h1.7c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.3,0.2-0.4,0.2h-1.7v-0.1h0.1v2.8h-0.1v-0.1h4c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.3,0.2-0.5,0.2L134.2,59.4L134.2,59.4L134.2,59.4z M125.9,58.8c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4V52v-0.2l0.1,0.2l1.1,1.6l0,0v0v0.3c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2 c0.1,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4v-0.3v0l0,0l1.1-1.6l0.1-0.2V52v6.9c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2 c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4v-8.5h0.1v0.1h-1.5v-0.1l0,0l-1.4,2l0,0.1l0-0.1l-1.4-2l0,0v0.1h-1.5v-0.1h0.1V58.8z  M125.8,58.8v-8.5v-0.1h0.1h1.5h0l0,0l1.4,2l0,0l0,0l1.4-2l0,0h0h1.5h0.1v0.1v8.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V52h0.1l0,0l-1.1,1.6l0,0h0.1v0.3c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5v-0.3h0.1l0,0L127,52l0,0h0.1v6.8 c0,0.2-0.1,0.3-0.2,0.5s-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2C125.8,59.2,125.8,59,125.8,58.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8354_",
    x: 92.9,
    y: 10.2,
    className: "st3",
    width: 24.9,
    height: 24.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8351_",
    className: "st4",
    cx: 142.8,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8348_",
    className: "st5",
    d: "M141.8,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C142.2,89.5,141.8,89.9,141.8,90.5z M141.8,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8347_",
    className: "st4",
    cx: 147.3,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8344_",
    className: "st5",
    d: "M146.3,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C146.8,89.5,146.3,89.9,146.3,90.5z M146.3,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8343_",
    className: "st4",
    cx: 151.8,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8340_",
    className: "st5",
    d: "M150.8,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C151.3,89.5,150.8,89.9,150.8,90.5z M150.8,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8339_",
    className: "st4",
    cx: 156.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8336_",
    className: "st5",
    d: "M155.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C155.8,89.5,155.4,89.9,155.4,90.5z M155.4,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8335_",
    className: "st4",
    cx: 160.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8332_",
    className: "st5",
    d: "M159.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C160.3,89.5,159.9,89.9,159.9,90.5z M159.9,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8331_",
    className: "st4",
    cx: 165.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8328_",
    className: "st5",
    d: "M164.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C164.9,89.5,164.4,89.9,164.4,90.5z M164.4,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8327_",
    className: "st4",
    cx: 169.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8324_",
    className: "st5",
    d: "M168.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1S168.9,89.9,168.9,90.5z  M168.9,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8323_",
    className: "st4",
    cx: 174.5,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8320_",
    className: "st5",
    d: "M173.5,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1S173.5,89.9,173.5,90.5z  M173.5,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8319_",
    className: "st4",
    cx: 102.1,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8316_",
    className: "st5",
    d: "M101.1,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C101.5,89.5,101.1,89.9,101.1,90.5z M101.1,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8315_",
    className: "st4",
    cx: 106.6,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8312_",
    className: "st5",
    d: "M105.6,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C106.1,89.5,105.6,89.9,105.6,90.5z M105.6,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8311_",
    className: "st4",
    cx: 111.1,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8308_",
    className: "st5",
    d: "M110.1,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C110.6,89.5,110.1,89.9,110.1,90.5z M110.1,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8298_",
    className: "st4",
    cx: 115.7,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8295_",
    className: "st5",
    d: "M114.6,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C115.1,89.5,114.6,89.9,114.6,90.5z M114.6,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8294_",
    className: "st4",
    cx: 120.2,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8291_",
    className: "st5",
    d: "M119.2,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C119.6,89.5,119.2,89.9,119.2,90.5z M119.2,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8290_",
    className: "st4",
    cx: 124.7,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8287_",
    className: "st5",
    d: "M123.7,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C124.1,89.5,123.7,89.9,123.7,90.5z M123.7,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8286_",
    className: "st4",
    cx: 129.2,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8283_",
    className: "st5",
    d: "M128.2,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C128.7,89.5,128.2,89.9,128.2,90.5z M128.2,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8282_",
    className: "st4",
    cx: 133.8,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8279_",
    className: "st5",
    d: "M132.7,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C133.2,89.5,132.7,89.9,132.7,90.5z M132.7,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8278_",
    className: "st4",
    cx: 165.4,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8275_",
    className: "st5",
    d: "M164.4,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C164.9,3.5,164.4,4,164.4,4.5z  M164.4,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8274_",
    className: "st4",
    cx: 160.9,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8271_",
    className: "st5",
    d: "M159.9,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C160.3,3.5,159.9,4,159.9,4.5z  M159.9,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8270_",
    className: "st4",
    cx: 156.4,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8267_",
    className: "st5",
    d: "M155.4,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C155.8,3.5,155.4,4,155.4,4.5z  M155.4,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8266_",
    className: "st4",
    cx: 151.8,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8263_",
    className: "st5",
    d: "M150.8,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C151.3,3.5,150.8,4,150.8,4.5z  M150.8,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8262_",
    className: "st4",
    cx: 147.3,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8259_",
    className: "st5",
    d: "M146.3,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C146.8,3.5,146.3,4,146.3,4.5z  M146.3,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8258_",
    className: "st4",
    cx: 142.8,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8255_",
    className: "st5",
    d: "M141.8,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C142.2,3.5,141.8,4,141.8,4.5z  M141.8,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8254_",
    className: "st4",
    cx: 138.3,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8251_",
    className: "st5",
    d: "M137.3,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C137.7,3.5,137.3,4,137.3,4.5z  M137.3,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8250_",
    className: "st4",
    cx: 133.8,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8247_",
    className: "st5",
    d: "M132.7,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C133.2,3.5,132.7,4,132.7,4.5z  M132.7,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8246_",
    className: "st4",
    cx: 45.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8243_",
    className: "st5",
    d: "M44.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C44.5,3.5,44.1,4,44.1,4.5z  M44.1,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8242_",
    className: "st4",
    cx: 49.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8239_",
    className: "st5",
    d: "M48.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C49.1,3.5,48.6,4,48.6,4.5z  M48.6,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8238_",
    className: "st4",
    cx: 54.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8235_",
    className: "st5",
    d: "M53.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C53.6,3.5,53.1,4,53.1,4.5z  M53.1,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8234_",
    className: "st4",
    cx: 58.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8231_",
    className: "st5",
    d: "M57.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C58.1,3.5,57.6,4,57.6,4.5z  M57.6,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8230_",
    className: "st4",
    cx: 63.2,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8227_",
    className: "st5",
    d: "M62.2,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C62.6,3.5,62.2,4,62.2,4.5z  M62.2,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8226_",
    className: "st4",
    cx: 67.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8223_",
    className: "st5",
    d: "M66.7,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C67.1,3.5,66.7,4,66.7,4.5z  M66.7,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8222_",
    className: "st4",
    cx: 72.2,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8219_",
    className: "st5",
    d: "M71.2,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C71.7,3.5,71.2,4,71.2,4.5z  M71.2,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8218_",
    className: "st4",
    cx: 76.8,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8215_",
    className: "st5",
    d: "M75.7,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C76.2,3.5,75.7,4,75.7,4.5z  M75.7,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8214_",
    className: "st4",
    cx: 81.3,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8211_",
    className: "st5",
    d: "M80.3,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C80.7,3.5,80.3,4,80.3,4.5z  M80.3,2.2h2v4.7h-2V2.2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8210_",
    className: "st4",
    cx: 85.8,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8198_",
    className: "st5",
    d: "M84.8,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C85.2,3.5,84.8,4,84.8,4.5z  M84.8,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8197_",
    className: "st4",
    cx: 61.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8194_",
    className: "st5",
    d: "M60.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C60.8,89.5,60.4,89.9,60.4,90.5z  M60.4,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8193_",
    className: "st4",
    cx: 65.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8190_",
    className: "st5",
    d: "M64.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C65.3,89.5,64.9,89.9,64.9,90.5z  M64.9,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8189_",
    className: "st4",
    cx: 70.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8186_",
    className: "st5",
    d: "M69.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C69.9,89.5,69.4,89.9,69.4,90.5z  M69.4,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8185_",
    className: "st4",
    cx: 74.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8182_",
    className: "st5",
    d: "M73.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C74.4,89.5,73.9,89.9,73.9,90.5z  M73.9,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8181_",
    className: "st4",
    cx: 79.5,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8178_",
    className: "st5",
    d: "M78.5,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C78.9,89.5,78.5,89.9,78.5,90.5z  M78.5,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8177_",
    className: "st4",
    cx: 84,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8174_",
    className: "st5",
    d: "M83,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C83.4,89.5,83,89.9,83,90.5z  M83,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8173_",
    className: "st4",
    cx: 88.5,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8170_",
    className: "st5",
    d: "M87.5,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C88,89.5,87.5,89.9,87.5,90.5z  M87.5,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8169_",
    className: "st4",
    cx: 93,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8166_",
    className: "st5",
    d: "M92,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C92.5,89.5,92,89.9,92,90.5z  M92,88.1h2v4.7h-2V88.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8165_",
    className: "st4",
    cx: 124.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8162_",
    className: "st5",
    d: "M123.7,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C124.1,3.5,123.7,4,123.7,4.5z  M123.7,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8161_",
    className: "st4",
    cx: 120.2,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8158_",
    className: "st5",
    d: "M119.2,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C119.6,3.5,119.2,4,119.2,4.5z  M119.2,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8157_",
    className: "st4",
    cx: 115.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8154_",
    className: "st5",
    d: "M114.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C115.1,3.5,114.6,4,114.6,4.5z  M114.6,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8153_",
    className: "st4",
    cx: 111.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8150_",
    className: "st5",
    d: "M110.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C110.6,3.5,110.1,4,110.1,4.5z  M110.1,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8149_",
    className: "st4",
    cx: 106.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8146_",
    className: "st5",
    d: "M105.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C106.1,3.5,105.6,4,105.6,4.5z  M105.6,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8145_",
    className: "st4",
    cx: 102.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8142_",
    className: "st5",
    d: "M101.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C101.5,3.5,101.1,4,101.1,4.5z  M101.1,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8141_",
    className: "st4",
    cx: 97.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8138_",
    className: "st5",
    d: "M96.5,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C97,3.5,96.5,4,96.5,4.5z  M96.5,2.2h2v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8137_",
    className: "st4",
    cx: 93,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8134_",
    className: "st5",
    d: "M92,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1C92.5,3.5,92,4,92,4.5z M92,2.2h2 v4.7h-2V2.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8133_",
    className: "st6",
    cx: 179,
    cy: 4.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8132_",
    className: "st6",
    cx: 183.5,
    cy: 4.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8131_",
    className: "st6",
    cx: 179,
    cy: 9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8130_",
    className: "st6",
    cx: 183.5,
    cy: 9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8129_",
    className: "st6",
    cx: 179,
    cy: 13.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8128_",
    className: "st6",
    cx: 183.5,
    cy: 13.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8127_",
    className: "st6",
    cx: 179,
    cy: 18.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8126_",
    className: "st6",
    cx: 183.5,
    cy: 18.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8125_",
    className: "st6",
    cx: 179,
    cy: 22.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8124_",
    className: "st6",
    cx: 183.5,
    cy: 22.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8123_",
    className: "st6",
    cx: 179,
    cy: 27.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8122_",
    className: "st6",
    cx: 183.5,
    cy: 27.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8121_",
    className: "st6",
    cx: 179,
    cy: 31.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8120_",
    className: "st6",
    cx: 183.5,
    cy: 31.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8119_",
    className: "st6",
    cx: 179,
    cy: 36.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8118_",
    className: "st6",
    cx: 183.5,
    cy: 36.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8117_",
    className: "st6",
    cx: 179,
    cy: 40.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8116_",
    className: "st6",
    cx: 183.5,
    cy: 40.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8115_",
    className: "st6",
    cx: 179,
    cy: 45.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8114_",
    className: "st6",
    cx: 183.5,
    cy: 45.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8113_",
    className: "st6",
    cx: 179,
    cy: 49.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8112_",
    className: "st6",
    cx: 183.5,
    cy: 49.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8111_",
    className: "st6",
    cx: 179,
    cy: 54.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8110_",
    className: "st6",
    cx: 183.5,
    cy: 54.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8100_",
    className: "st6",
    cx: 179,
    cy: 58.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8099_",
    className: "st6",
    cx: 183.5,
    cy: 58.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8098_",
    className: "st6",
    cx: 179,
    cy: 63.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8097_",
    className: "st6",
    cx: 183.5,
    cy: 63.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8096_",
    className: "st6",
    cx: 179,
    cy: 67.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8095_",
    className: "st6",
    cx: 183.5,
    cy: 67.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8094_",
    className: "st6",
    cx: 179,
    cy: 72.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8093_",
    className: "st6",
    cx: 183.5,
    cy: 72.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8092_",
    className: "st6",
    cx: 179,
    cy: 76.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8091_",
    className: "st6",
    cx: 183.5,
    cy: 76.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8090_",
    className: "st6",
    cx: 179,
    cy: 81.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8089_",
    className: "st6",
    cx: 183.5,
    cy: 81.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8088_",
    x: 140.5,
    y: 88.2,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8087_",
    x: 141.9,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8086_",
    className: "st8",
    points: "141.3,89 141.9,89.6 143.7,89.6 144.3,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8085_",
    className: "st9",
    points: "144.3,89 143.7,89.6 143.7,91.4 144.3,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8084_",
    className: "st10",
    points: "144.3,92 143.7,91.4 141.9,91.4 141.3,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8083_",
    className: "st11",
    points: "141.3,92 141.9,91.4 141.9,89.6 141.3,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8082_",
    x: 146.4,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8081_",
    className: "st8",
    points: "145.8,89 146.4,89.6 148.2,89.6 148.8,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8080_",
    className: "st9",
    points: "148.8,89 148.2,89.6 148.2,91.4 148.8,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8079_",
    className: "st10",
    points: "148.8,92 148.2,91.4 146.4,91.4 145.8,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8078_",
    className: "st11",
    points: "145.8,92 146.4,91.4 146.4,89.6 145.8,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8077_",
    x: 151,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8076_",
    className: "st8",
    points: "150.3,89 151,89.6 152.7,89.6 153.4,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8075_",
    className: "st9",
    points: "153.4,89 152.7,89.6 152.7,91.4 153.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8074_",
    className: "st10",
    points: "153.4,92 152.7,91.4 151,91.4 150.3,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8073_",
    className: "st11",
    points: "150.3,92 151,91.4 151,89.6 150.3,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8072_",
    x: 155.5,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8071_",
    className: "st8",
    points: "154.8,89 155.5,89.6 157.2,89.6 157.9,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8070_",
    className: "st9",
    points: "157.9,89 157.2,89.6 157.2,91.4 157.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8069_",
    className: "st10",
    points: "157.9,92 157.2,91.4 155.5,91.4 154.8,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8068_",
    className: "st11",
    points: "154.8,92 155.5,91.4 155.5,89.6 154.8,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8067_",
    x: 160,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8066_",
    className: "st8",
    points: "159.4,89 160,89.6 161.8,89.6 162.4,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8065_",
    className: "st9",
    points: "162.4,89 161.8,89.6 161.8,91.4 162.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8064_",
    className: "st10",
    points: "162.4,92 161.8,91.4 160,91.4 159.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8063_",
    className: "st11",
    points: "159.4,92 160,91.4 160,89.6 159.4,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8062_",
    x: 164.5,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8061_",
    className: "st8",
    points: "163.9,89 164.5,89.6 166.3,89.6 166.9,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8060_",
    className: "st9",
    points: "166.9,89 166.3,89.6 166.3,91.4 166.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8059_",
    className: "st10",
    points: "166.9,92 166.3,91.4 164.5,91.4 163.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8058_",
    className: "st11",
    points: "163.9,92 164.5,91.4 164.5,89.6 163.9,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8057_",
    x: 169.1,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8056_",
    className: "st8",
    points: "168.4,89 169.1,89.6 170.8,89.6 171.5,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8055_",
    className: "st9",
    points: "171.5,89 170.8,89.6 170.8,91.4 171.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8054_",
    className: "st10",
    points: "171.5,92 170.8,91.4 169.1,91.4 168.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8053_",
    className: "st11",
    points: "168.4,92 169.1,91.4 169.1,89.6 168.4,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8052_",
    x: 173.6,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8051_",
    className: "st8",
    points: "172.9,89 173.6,89.6 175.3,89.6 176,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8050_",
    className: "st9",
    points: "176,89 175.3,89.6 175.3,91.4 176,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8049_",
    className: "st10",
    points: "176,92 175.3,91.4 173.6,91.4 172.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8048_",
    className: "st11",
    points: "172.9,92 173.6,91.4 173.6,89.6 172.9,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8047_",
    x: 99.8,
    y: 88.2,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8046_",
    x: 101.2,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8045_",
    className: "st8",
    points: "100.6,89 101.2,89.6 103,89.6 103.6,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8044_",
    className: "st9",
    points: "103.6,89 103,89.6 103,91.4 103.6,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8043_",
    className: "st10",
    points: "103.6,92 103,91.4 101.2,91.4 100.6,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8042_",
    className: "st11",
    points: "100.6,92 101.2,91.4 101.2,89.6 100.6,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8041_",
    x: 105.7,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8040_",
    className: "st8",
    points: "105.1,89 105.7,89.6 107.5,89.6 108.1,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8039_",
    className: "st9",
    points: "108.1,89 107.5,89.6 107.5,91.4 108.1,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8038_",
    className: "st10",
    points: "108.1,92 107.5,91.4 105.7,91.4 105.1,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8037_",
    className: "st11",
    points: "105.1,92 105.7,91.4 105.7,89.6 105.1,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8036_",
    x: 110.3,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8035_",
    className: "st8",
    points: "109.6,89 110.3,89.6 112,89.6 112.6,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8034_",
    className: "st9",
    points: "112.6,89 112,89.6 112,91.4 112.6,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8033_",
    className: "st10",
    points: "112.6,92 112,91.4 110.3,91.4 109.6,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8032_",
    className: "st11",
    points: "109.6,92 110.3,91.4 110.3,89.6 109.6,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8031_",
    x: 114.8,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8030_",
    className: "st8",
    points: "114.1,89 114.8,89.6 116.5,89.6 117.2,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8029_",
    className: "st9",
    points: "117.2,89 116.5,89.6 116.5,91.4 117.2,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8028_",
    className: "st10",
    points: "117.2,92 116.5,91.4 114.8,91.4 114.1,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8027_",
    className: "st11",
    points: "114.1,92 114.8,91.4 114.8,89.6 114.1,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8026_",
    x: 119.3,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8025_",
    className: "st8",
    points: "118.7,89 119.3,89.6 121,89.6 121.7,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8024_",
    className: "st9",
    points: "121.7,89 121,89.6 121,91.4 121.7,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8023_",
    className: "st10",
    points: "121.7,92 121,91.4 119.3,91.4 118.7,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8022_",
    className: "st11",
    points: "118.7,92 119.3,91.4 119.3,89.6 118.7,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8021_",
    x: 123.8,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8020_",
    className: "st8",
    points: "123.2,89 123.8,89.6 125.6,89.6 126.2,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8019_",
    className: "st9",
    points: "126.2,89 125.6,89.6 125.6,91.4 126.2,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8018_",
    className: "st10",
    points: "126.2,92 125.6,91.4 123.8,91.4 123.2,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8017_",
    className: "st11",
    points: "123.2,92 123.8,91.4 123.8,89.6 123.2,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8016_",
    x: 128.3,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8015_",
    className: "st8",
    points: "127.7,89 128.3,89.6 130.1,89.6 130.7,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8014_",
    className: "st9",
    points: "130.7,89 130.1,89.6 130.1,91.4 130.7,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8013_",
    className: "st10",
    points: "130.7,92 130.1,91.4 128.3,91.4 127.7,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8012_",
    className: "st11",
    points: "127.7,92 128.3,91.4 128.3,89.6 127.7,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8011_",
    x: 132.9,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8001_",
    className: "st8",
    points: "132.2,89 132.9,89.6 134.6,89.6 135.3,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8000_",
    className: "st9",
    points: "135.3,89 134.6,89.6 134.6,91.4 135.3,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7999_",
    className: "st10",
    points: "135.3,92 134.6,91.4 132.9,91.4 132.2,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7998_",
    className: "st11",
    points: "132.2,92 132.9,91.4 132.9,89.6 132.2,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7997_",
    x: 131.5,
    y: 2.3,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7996_",
    x: 164.6,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7995_",
    className: "st8",
    points: "166.9,6 166.3,5.4 164.6,5.4 163.9,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7994_",
    className: "st9",
    points: "163.9,6 164.6,5.4 164.6,3.6 163.9,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7993_",
    className: "st10",
    points: "163.9,3 164.6,3.6 166.3,3.6 166.9,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7992_",
    className: "st11",
    points: "166.9,3 166.3,3.6 166.3,5.4 166.9,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7991_",
    x: 160,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7990_",
    className: "st8",
    points: "162.4,6 161.8,5.4 160,5.4 159.4,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7989_",
    className: "st9",
    points: "159.4,6 160,5.4 160,3.6 159.4,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7988_",
    className: "st10",
    points: "159.4,3 160,3.6 161.8,3.6 162.4,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7987_",
    className: "st11",
    points: "162.4,3 161.8,3.6 161.8,5.4 162.4,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7986_",
    x: 155.5,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7985_",
    className: "st8",
    points: "157.9,6 157.3,5.4 155.5,5.4 154.9,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7984_",
    className: "st9",
    points: "154.9,6 155.5,5.4 155.5,3.6 154.9,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7983_",
    className: "st10",
    points: "154.9,3 155.5,3.6 157.3,3.6 157.9,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7982_",
    className: "st11",
    points: "157.9,3 157.3,3.6 157.3,5.4 157.9,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7981_",
    x: 151,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7980_",
    className: "st8",
    points: "153.4,6 152.7,5.4 151,5.4 150.3,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7979_",
    className: "st9",
    points: "150.3,6 151,5.4 151,3.6 150.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7978_",
    className: "st10",
    points: "150.3,3 151,3.6 152.7,3.6 153.4,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7977_",
    className: "st11",
    points: "153.4,3 152.7,3.6 152.7,5.4 153.4,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7976_",
    x: 146.5,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7975_",
    className: "st8",
    points: "148.8,6 148.2,5.4 146.5,5.4 145.8,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7974_",
    className: "st9",
    points: "145.8,6 146.5,5.4 146.5,3.6 145.8,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7973_",
    className: "st10",
    points: "145.8,3 146.5,3.6 148.2,3.6 148.8,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7972_",
    className: "st11",
    points: "148.8,3 148.2,3.6 148.2,5.4 148.8,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7971_",
    x: 141.9,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7970_",
    className: "st8",
    points: "144.3,6 143.7,5.4 141.9,5.4 141.3,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7969_",
    className: "st9",
    points: "141.3,6 141.9,5.4 141.9,3.6 141.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7968_",
    className: "st10",
    points: "141.3,3 141.9,3.6 143.7,3.6 144.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7967_",
    className: "st11",
    points: "144.3,3 143.7,3.6 143.7,5.4 144.3,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7966_",
    x: 137.4,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7965_",
    className: "st8",
    points: "139.8,6 139.2,5.4 137.4,5.4 136.8,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7964_",
    className: "st9",
    points: "136.8,6 137.4,5.4 137.4,3.6 136.8,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7963_",
    className: "st10",
    points: "136.8,3 137.4,3.6 139.2,3.6 139.8,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7962_",
    className: "st11",
    points: "139.8,3 139.2,3.6 139.2,5.4 139.8,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7961_",
    x: 132.9,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7960_",
    className: "st8",
    points: "135.3,6 134.6,5.4 132.9,5.4 132.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7959_",
    className: "st9",
    points: "132.2,6 132.9,5.4 132.9,3.6 132.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7958_",
    className: "st10",
    points: "132.2,3 132.9,3.6 134.6,3.6 135.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7957_",
    className: "st11",
    points: "135.3,3 134.6,3.6 134.6,5.4 135.3,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7956_",
    x: 31.5,
    y: 62.1,
    className: "st12",
    width: 4.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7955_",
    x: 31.5,
    y: 56.4,
    className: "st12",
    width: 4.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7954_",
    x: 31.5,
    y: 50.7,
    className: "st12",
    width: 4.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7953_",
    x: 35.6,
    y: 62.1,
    className: "st13",
    width: 0.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7952_",
    x: 35.6,
    y: 56.4,
    className: "st13",
    width: 0.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7951_",
    x: 35.6,
    y: 50.7,
    className: "st13",
    width: 0.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7950_",
    x: 18.2,
    y: 53.5,
    className: "st12",
    width: 4.6,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7949_",
    x: 18.2,
    y: 53.5,
    className: "st13",
    width: 0.1,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7948_",
    x: 22.8,
    y: 49.6,
    className: "st14",
    width: 8.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7947_",
    className: "st15",
    points: "22.8,66.3 22.8,49.6 23.5,50.2 23.5,65.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7946_",
    className: "st15",
    points: "31.5,66.3 31.5,49.6 30.9,50.2 30.9,65.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7944_",
    className: "st16",
    points: "22.8,49.6 31.5,49.6 30.9,50.2 23.5,50.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7943_",
    className: "st17",
    cx: 29.6,
    cy: 64.4,
    r: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2239_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7942_",
    className: "st7",
    points: "131.9,10.2 129.4,10.2 127.3,10.2 124.8,10.2 123.9,11.1 123.9,13.6 124.8,14.5  127.3,14.5 129.4,14.5 131.9,14.5 132.8,13.6 132.8,11.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7941_",
    className: "st7",
    points: "131.9,14.7 129.4,14.7 127.3,14.7 124.8,14.7 123.9,15.6 123.9,18.1 124.8,19  127.3,19 129.4,19 131.9,19 132.8,18.1 132.8,15.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7940_",
    className: "st7",
    points: "131.9,19.2 129.4,19.2 127.3,19.2 124.8,19.2 123.9,20.1 123.9,22.6 124.8,23.6  127.3,23.6 129.4,23.6 131.9,23.6 132.8,22.6 132.8,20.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7939_",
    className: "st7",
    points: "131.9,10.2 129.4,10.2 127.3,10.2 124.8,10.2 123.9,11.1 123.9,13.6 124.8,14.5  127.3,14.5 129.4,14.5 131.9,14.5 132.8,13.6 132.8,11.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7938_",
    className: "st7",
    points: "131.9,14.7 129.4,14.7 127.3,14.7 124.8,14.7 123.9,15.6 123.9,18.1 124.8,19  127.3,19 129.4,19 131.9,19 132.8,18.1 132.8,15.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7937_",
    className: "st7",
    points: "131.9,19.2 129.4,19.2 127.3,19.2 124.8,19.2 123.9,20.1 123.9,22.6 124.8,23.6  127.3,23.6 129.4,23.6 131.9,23.6 132.8,22.6 132.8,20.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7936_",
    x: 125.4,
    y: 20.6,
    className: "st18",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7935_",
    x: 129.9,
    y: 20.6,
    className: "st18",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7934_",
    x: 125.4,
    y: 16,
    className: "st18",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7933_",
    x: 129.9,
    y: 16,
    className: "st18",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7932_",
    x: 125.4,
    y: 11.5,
    className: "st18",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7931_",
    x: 129.9,
    y: 11.5,
    className: "st19",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7930_",
    x: 130.3,
    y: 11.9,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7929_",
    className: "st21",
    points: "129.9,11.5 130.3,11.9 131,11.9 131.4,11.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7928_",
    className: "st22",
    points: "131,12.6 131,11.9 131.4,11.5 131.4,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7927_",
    className: "st23",
    points: "130.3,12.6 131,12.6 131.4,13 129.9,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7926_",
    className: "st5",
    points: "129.9,11.5 130.3,11.9 130.3,12.6 129.9,13  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7925_",
    x: 125.8,
    y: 11.9,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7924_",
    className: "st21",
    points: "125.4,11.5 125.8,11.9 126.5,11.9 126.8,11.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7923_",
    className: "st22",
    points: "126.5,12.6 126.5,11.9 126.8,11.5 126.8,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7922_",
    className: "st23",
    points: "125.8,12.6 126.5,12.6 126.8,13 125.4,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7921_",
    className: "st5",
    points: "125.4,11.5 125.8,11.9 125.8,12.6 125.4,13  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7920_",
    x: 130.3,
    y: 16.4,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7919_",
    className: "st21",
    points: "129.9,16 130.3,16.4 131,16.4 131.4,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7918_",
    className: "st22",
    points: "131,17.1 131,16.4 131.4,16 131.4,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7917_",
    className: "st23",
    points: "130.3,17.1 131,17.1 131.4,17.5 129.9,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7916_",
    className: "st5",
    points: "129.9,16 130.3,16.4 130.3,17.1 129.9,17.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7915_",
    x: 125.8,
    y: 16.4,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7914_",
    className: "st21",
    points: "125.4,16 125.8,16.4 126.5,16.4 126.8,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7913_",
    className: "st22",
    points: "126.5,17.1 126.5,16.4 126.8,16 126.8,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7912_",
    className: "st23",
    points: "125.8,17.1 126.5,17.1 126.8,17.5 125.4,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7902_",
    className: "st5",
    points: "125.4,16 125.8,16.4 125.8,17.1 125.4,17.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7901_",
    x: 130.3,
    y: 20.9,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7900_",
    className: "st21",
    points: "129.9,20.6 130.3,20.9 131,20.9 131.4,20.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7899_",
    className: "st22",
    points: "131,21.7 131,20.9 131.4,20.6 131.4,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7898_",
    className: "st23",
    points: "130.3,21.7 131,21.7 131.4,22 129.9,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7897_",
    className: "st5",
    points: "129.9,20.6 130.3,20.9 130.3,21.7 129.9,22  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7896_",
    x: 125.8,
    y: 20.9,
    className: "st20",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7895_",
    className: "st21",
    points: "125.4,20.6 125.8,20.9 126.5,20.9 126.8,20.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7894_",
    className: "st22",
    points: "126.5,21.7 126.5,20.9 126.8,20.6 126.8,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7893_",
    className: "st23",
    points: "125.8,21.7 126.5,21.7 126.8,22 125.4,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7892_",
    className: "st5",
    points: "125.4,20.6 125.8,20.9 125.8,21.7 125.4,22  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2241_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8353_",
    x: 41.7,
    y: 28.6,
    className: "st3",
    width: 11.2,
    height: 11.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2240_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7891_",
    className: "st7",
    points: "36,11.4 36,14.5 36,17.1 36,20.2 37.2,21.4 40.3,21.4 41.5,20.2 41.5,17.1  41.5,14.5 41.5,11.4 40.3,10.2 37.2,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7890_",
    className: "st7",
    points: "41.7,11.4 41.7,14.5 41.7,17.1 41.7,20.2 42.9,21.4 46,21.4 47.2,20.2 47.2,17.1  47.2,14.5 47.2,11.4 46,10.2 42.9,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7889_",
    className: "st7",
    points: "47.4,11.4 47.4,14.5 47.4,17.1 47.4,20.2 48.6,21.4 51.7,21.4 52.9,20.2  52.9,17.1 52.9,14.5 52.9,11.4 51.7,10.2 48.6,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7888_",
    className: "st7",
    points: "36,11.4 36,14.5 36,17.1 36,20.2 37.2,21.4 40.3,21.4 41.5,20.2 41.5,17.1  41.5,14.5 41.5,11.4 40.3,10.2 37.2,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7887_",
    className: "st7",
    points: "41.7,11.4 41.7,14.5 41.7,17.1 41.7,20.2 42.9,21.4 46,21.4 47.2,20.2 47.2,17.1  47.2,14.5 47.2,11.4 46,10.2 42.9,10.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7886_",
    className: "st7",
    points: "47.4,11.4 47.4,14.5 47.4,17.1 47.4,20.2 48.6,21.4 51.7,21.4 52.9,20.2  52.9,17.1 52.9,14.5 52.9,11.4 51.7,10.2 48.6,10.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7885_",
    x: 49.1,
    y: 17.7,
    className: "st18",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7884_",
    x: 49.1,
    y: 12,
    className: "st18",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7883_",
    x: 43.4,
    y: 17.7,
    className: "st18",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7882_",
    x: 43.4,
    y: 12,
    className: "st18",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7881_",
    x: 37.7,
    y: 17.7,
    className: "st18",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7880_",
    x: 37.7,
    y: 12,
    className: "st19",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7879_",
    x: 38.2,
    y: 12.4,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7878_",
    className: "st21",
    points: "37.7,13.8 38.2,13.4 38.2,12.4 37.7,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7877_",
    className: "st22",
    points: "39.1,12.4 38.2,12.4 37.7,12 39.5,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7876_",
    className: "st23",
    points: "39.1,13.4 39.1,12.4 39.5,12 39.5,13.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7875_",
    className: "st5",
    points: "37.7,13.8 38.2,13.4 39.1,13.4 39.5,13.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7874_",
    x: 38.2,
    y: 18.1,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7873_",
    className: "st21",
    points: "37.7,19.5 38.2,19.1 38.2,18.1 37.7,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7872_",
    className: "st22",
    points: "39.1,18.1 38.2,18.1 37.7,17.7 39.5,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7871_",
    className: "st23",
    points: "39.1,19.1 39.1,18.1 39.5,17.7 39.5,19.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7870_",
    className: "st5",
    points: "37.7,19.5 38.2,19.1 39.1,19.1 39.5,19.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7869_",
    x: 43.9,
    y: 12.4,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7868_",
    className: "st21",
    points: "43.4,13.8 43.9,13.4 43.9,12.4 43.4,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7867_",
    className: "st22",
    points: "44.8,12.4 43.9,12.4 43.4,12 45.2,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7866_",
    className: "st23",
    points: "44.8,13.4 44.8,12.4 45.2,12 45.2,13.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7865_",
    className: "st5",
    points: "43.4,13.8 43.9,13.4 44.8,13.4 45.2,13.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7864_",
    x: 43.9,
    y: 18.1,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7863_",
    className: "st21",
    points: "43.4,19.5 43.9,19.1 43.9,18.1 43.4,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7862_",
    className: "st22",
    points: "44.8,18.1 43.9,18.1 43.4,17.7 45.2,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7861_",
    className: "st23",
    points: "44.8,19.1 44.8,18.1 45.2,17.7 45.2,19.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7860_",
    className: "st5",
    points: "43.4,19.5 43.9,19.1 44.8,19.1 45.2,19.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7859_",
    x: 49.6,
    y: 12.4,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7858_",
    className: "st21",
    points: "49.1,13.8 49.6,13.4 49.6,12.4 49.1,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7857_",
    className: "st22",
    points: "50.5,12.4 49.6,12.4 49.1,12 50.9,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7856_",
    className: "st23",
    points: "50.5,13.4 50.5,12.4 50.9,12 50.9,13.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7855_",
    className: "st5",
    points: "49.1,13.8 49.6,13.4 50.5,13.4 50.9,13.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7854_",
    x: 49.6,
    y: 18.1,
    className: "st20",
    width: 0.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7853_",
    className: "st21",
    points: "49.1,19.5 49.6,19.1 49.6,18.1 49.1,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7852_",
    className: "st22",
    points: "50.5,18.1 49.6,18.1 49.1,17.7 50.9,17.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7851_",
    className: "st23",
    points: "50.5,19.1 50.5,18.1 50.9,17.7 50.9,19.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7850_",
    className: "st5",
    points: "49.1,19.5 49.6,19.1 50.5,19.1 50.9,19.5  "
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7849_",
    x: 42.8,
    y: 2.3,
    className: "st7",
    width: 45.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7848_",
    x: 44.2,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7847_",
    className: "st8",
    points: "43.6,3 44.2,3.7 46,3.7 46.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7846_",
    className: "st9",
    points: "46.6,3 46,3.7 46,5.4 46.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7845_",
    className: "st10",
    points: "46.6,6 46,5.4 44.2,5.4 43.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7844_",
    className: "st11",
    points: "43.6,6 44.2,5.4 44.2,3.7 43.6,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7843_",
    x: 48.7,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7842_",
    className: "st8",
    points: "48.1,3 48.7,3.7 50.5,3.7 51.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7841_",
    className: "st9",
    points: "51.1,3 50.5,3.7 50.5,5.4 51.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7840_",
    className: "st10",
    points: "51.1,6 50.5,5.4 48.7,5.4 48.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7839_",
    className: "st11",
    points: "48.1,6 48.7,5.4 48.7,3.7 48.1,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7838_",
    x: 53.3,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7837_",
    className: "st8",
    points: "52.6,3 53.3,3.7 55,3.7 55.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7836_",
    className: "st9",
    points: "55.6,3 55,3.7 55,5.4 55.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7835_",
    className: "st10",
    points: "55.6,6 55,5.4 53.3,5.4 52.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7834_",
    className: "st11",
    points: "52.6,6 53.3,5.4 53.3,3.7 52.6,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7833_",
    x: 57.8,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7832_",
    className: "st8",
    points: "57.1,3 57.8,3.7 59.5,3.7 60.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7831_",
    className: "st9",
    points: "60.2,3 59.5,3.7 59.5,5.4 60.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7830_",
    className: "st10",
    points: "60.2,6 59.5,5.4 57.8,5.4 57.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7829_",
    className: "st11",
    points: "57.1,6 57.8,5.4 57.8,3.7 57.1,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7828_",
    x: 62.3,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7827_",
    className: "st8",
    points: "61.7,3 62.3,3.7 64,3.7 64.7,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7826_",
    className: "st9",
    points: "64.7,3 64,3.7 64,5.4 64.7,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7825_",
    className: "st10",
    points: "64.7,6 64,5.4 62.3,5.4 61.7,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7824_",
    className: "st11",
    points: "61.7,6 62.3,5.4 62.3,3.7 61.7,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7823_",
    x: 66.8,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7822_",
    className: "st8",
    points: "66.2,3 66.8,3.7 68.6,3.7 69.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7821_",
    className: "st9",
    points: "69.2,3 68.6,3.7 68.6,5.4 69.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7820_",
    className: "st10",
    points: "69.2,6 68.6,5.4 66.8,5.4 66.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7819_",
    className: "st11",
    points: "66.2,6 66.8,5.4 66.8,3.7 66.2,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7818_",
    x: 71.3,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7817_",
    className: "st8",
    points: "70.7,3 71.3,3.7 73.1,3.7 73.7,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7816_",
    className: "st9",
    points: "73.7,3 73.1,3.7 73.1,5.4 73.7,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7815_",
    className: "st10",
    points: "73.7,6 73.1,5.4 71.3,5.4 70.7,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7814_",
    className: "st11",
    points: "70.7,6 71.3,5.4 71.3,3.7 70.7,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7813_",
    x: 75.9,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7803_",
    className: "st8",
    points: "75.2,3 75.9,3.7 77.6,3.7 78.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7802_",
    className: "st9",
    points: "78.3,3 77.6,3.7 77.6,5.4 78.3,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7801_",
    className: "st10",
    points: "78.3,6 77.6,5.4 75.9,5.4 75.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7800_",
    className: "st11",
    points: "75.2,6 75.9,5.4 75.9,3.7 75.2,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7799_",
    x: 80.4,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7798_",
    className: "st8",
    points: "79.8,3 80.4,3.7 82.1,3.7 82.8,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7797_",
    className: "st9",
    points: "82.8,3 82.1,3.7 82.1,5.4 82.8,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7796_",
    className: "st10",
    points: "82.8,6 82.1,5.4 80.4,5.4 79.8,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7795_",
    className: "st11",
    points: "79.7,6 80.4,5.4 80.4,3.7 79.7,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7794_",
    x: 84.9,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7793_",
    className: "st8",
    points: "84.3,3 84.9,3.7 86.7,3.7 87.3,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7792_",
    className: "st9",
    points: "87.3,3 86.7,3.7 86.7,5.4 87.3,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7791_",
    className: "st10",
    points: "87.3,6 86.7,5.4 84.9,5.4 84.3,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7790_",
    className: "st11",
    points: "84.3,6 84.9,5.4 84.9,3.7 84.3,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7789_",
    x: 176.7,
    y: 2.3,
    className: "st7",
    width: 4.5,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7788_",
    x: 178.1,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7787_",
    className: "st8",
    points: "180.5,3 179.9,3.7 179.9,5.4 180.5,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7786_",
    className: "st9",
    points: "180.5,6 179.9,5.4 178.1,5.4 177.5,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7785_",
    className: "st10",
    points: "177.5,6 178.1,5.4 178.1,3.7 177.5,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7783_",
    x: 178.1,
    y: 8.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7782_",
    className: "st8",
    points: "180.5,7.5 179.9,8.2 179.9,9.9 180.5,10.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7781_",
    className: "st9",
    points: "180.5,10.6 179.9,9.9 178.1,9.9 177.5,10.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7780_",
    className: "st10",
    points: "177.5,10.6 178.1,9.9 178.1,8.2 177.5,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7779_",
    className: "st11",
    points: "177.5,7.5 178.1,8.2 179.9,8.2 180.5,7.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7778_",
    x: 178.1,
    y: 12.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7777_",
    className: "st8",
    points: "180.5,12.1 179.9,12.7 179.9,14.5 180.5,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7776_",
    className: "st9",
    points: "180.5,15.1 179.9,14.5 178.1,14.5 177.5,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7775_",
    className: "st10",
    points: "177.5,15.1 178.1,14.4 178.1,12.7 177.5,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7774_",
    className: "st11",
    points: "177.5,12.1 178.1,12.7 179.9,12.7 180.5,12.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7773_",
    x: 178.1,
    y: 17.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7772_",
    className: "st8",
    points: "180.5,16.6 179.9,17.2 179.9,19 180.5,19.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7771_",
    className: "st9",
    points: "180.5,19.6 179.9,19 178.1,19 177.5,19.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7770_",
    className: "st10",
    points: "177.5,19.6 178.1,19 178.1,17.2 177.5,16.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7769_",
    className: "st11",
    points: "177.5,16.6 178.1,17.2 179.9,17.2 180.5,16.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7768_",
    x: 178.1,
    y: 21.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7767_",
    className: "st8",
    points: "180.5,21.1 179.9,21.7 179.9,23.5 180.5,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7766_",
    className: "st9",
    points: "180.5,24.1 179.9,23.5 178.1,23.5 177.5,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7765_",
    className: "st10",
    points: "177.5,24.1 178.1,23.5 178.1,21.7 177.5,21.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7764_",
    className: "st11",
    points: "177.5,21.1 178.1,21.7 179.9,21.7 180.5,21.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7763_",
    x: 178.1,
    y: 26.3,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7762_",
    className: "st8",
    points: "180.5,25.6 179.9,26.3 179.9,28 180.5,28.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7761_",
    className: "st9",
    points: "180.5,28.7 179.9,28 178.1,28 177.5,28.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7760_",
    className: "st10",
    points: "177.5,28.7 178.1,28 178.1,26.3 177.5,25.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7759_",
    className: "st11",
    points: "177.5,25.6 178.1,26.3 179.9,26.3 180.5,25.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7758_",
    x: 178.1,
    y: 30.8,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7757_",
    className: "st8",
    points: "180.5,30.2 179.9,30.8 179.9,32.5 180.5,33.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7756_",
    className: "st9",
    points: "180.5,33.2 179.9,32.5 178.1,32.5 177.5,33.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7755_",
    className: "st10",
    points: "177.5,33.2 178.1,32.5 178.1,30.8 177.5,30.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7754_",
    className: "st11",
    points: "177.5,30.2 178.1,30.8 179.9,30.8 180.5,30.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7753_",
    x: 178.1,
    y: 35.3,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7752_",
    className: "st8",
    points: "180.5,34.7 179.9,35.3 179.9,37.1 180.5,37.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7751_",
    className: "st9",
    points: "180.5,37.7 179.9,37.1 178.1,37.1 177.5,37.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7750_",
    className: "st10",
    points: "177.5,37.7 178.1,37.1 178.1,35.3 177.5,34.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7749_",
    className: "st11",
    points: "177.5,34.7 178.1,35.3 179.9,35.3 180.5,34.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7748_",
    x: 176.7,
    y: 38.5,
    className: "st7",
    width: 4.5,
    height: 45.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7747_",
    x: 178.1,
    y: 39.8,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7746_",
    className: "st8",
    points: "180.5,39.2 179.9,39.8 179.9,41.6 180.5,42.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7745_",
    className: "st9",
    points: "180.5,42.2 179.9,41.6 178.1,41.6 177.5,42.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7744_",
    className: "st10",
    points: "177.5,42.2 178.1,41.6 178.1,39.8 177.5,39.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7743_",
    className: "st11",
    points: "177.5,39.2 178.1,39.8 179.9,39.8 180.5,39.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7742_",
    x: 178.1,
    y: 44.4,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7741_",
    className: "st8",
    points: "180.5,43.7 179.9,44.4 179.9,46.1 180.5,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7740_",
    className: "st9",
    points: "180.5,46.8 179.9,46.1 178.1,46.1 177.5,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7739_",
    className: "st10",
    points: "177.5,46.8 178.1,46.1 178.1,44.4 177.5,43.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7738_",
    className: "st11",
    points: "177.5,43.7 178.1,44.4 179.9,44.4 180.5,43.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7737_",
    x: 178.1,
    y: 48.9,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7736_",
    className: "st8",
    points: "180.5,48.2 179.9,48.9 179.9,50.6 180.5,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7735_",
    className: "st9",
    points: "180.5,51.3 179.9,50.6 178.1,50.6 177.5,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7734_",
    className: "st10",
    points: "177.5,51.3 178.1,50.6 178.1,48.9 177.5,48.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7733_",
    className: "st11",
    points: "177.5,48.2 178.1,48.9 179.9,48.9 180.5,48.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7732_",
    x: 178.1,
    y: 53.4,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7731_",
    className: "st8",
    points: "180.5,52.8 179.9,53.4 179.9,55.2 180.5,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7730_",
    className: "st9",
    points: "180.5,55.8 179.9,55.2 178.1,55.2 177.5,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7729_",
    className: "st10",
    points: "177.5,55.8 178.1,55.2 178.1,53.4 177.5,52.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7728_",
    className: "st11",
    points: "177.5,52.8 178.1,53.4 179.9,53.4 180.5,52.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7727_",
    x: 178.1,
    y: 57.9,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7726_",
    className: "st8",
    points: "180.5,57.3 179.9,57.9 179.9,59.7 180.5,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7725_",
    className: "st9",
    points: "180.5,60.3 179.9,59.7 178.1,59.7 177.5,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7724_",
    className: "st10",
    points: "177.5,60.3 178.1,59.7 178.1,57.9 177.5,57.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7723_",
    className: "st11",
    points: "177.5,57.3 178.1,57.9 179.9,57.9 180.5,57.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7722_",
    x: 178.1,
    y: 62.5,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7721_",
    className: "st8",
    points: "180.5,61.8 179.9,62.5 179.9,64.2 180.5,64.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7720_",
    className: "st9",
    points: "180.5,64.9 179.9,64.2 178.1,64.2 177.5,64.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7719_",
    className: "st10",
    points: "177.5,64.9 178.1,64.2 178.1,62.5 177.5,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7718_",
    className: "st11",
    points: "177.5,61.8 178.1,62.5 179.9,62.5 180.5,61.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7717_",
    x: 178.1,
    y: 67,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7716_",
    className: "st8",
    points: "180.5,66.3 179.9,67 179.9,68.7 180.5,69.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7715_",
    className: "st9",
    points: "180.5,69.4 179.9,68.7 178.1,68.7 177.5,69.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7714_",
    className: "st10",
    points: "177.5,69.4 178.1,68.7 178.1,67 177.5,66.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7704_",
    className: "st11",
    points: "177.5,66.3 178.1,67 179.9,67 180.5,66.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7703_",
    x: 178.1,
    y: 71.5,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7702_",
    className: "st8",
    points: "180.5,70.9 179.9,71.5 179.9,73.3 180.5,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7701_",
    className: "st9",
    points: "180.5,73.9 179.9,73.3 178.1,73.3 177.5,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7700_",
    className: "st10",
    points: "177.5,73.9 178.1,73.3 178.1,71.5 177.5,70.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7699_",
    className: "st11",
    points: "177.5,70.9 178.1,71.5 179.9,71.5 180.5,70.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7698_",
    x: 178.1,
    y: 76,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7697_",
    className: "st8",
    points: "180.5,75.4 179.9,76 179.9,77.8 180.5,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7696_",
    className: "st9",
    points: "180.5,78.4 179.9,77.8 178.1,77.8 177.5,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7695_",
    className: "st10",
    points: "177.5,78.4 178.1,77.8 178.1,76 177.5,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7694_",
    className: "st11",
    points: "177.5,75.4 178.1,76 179.9,76 180.5,75.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7693_",
    x: 178.1,
    y: 80.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7692_",
    className: "st8",
    points: "180.5,79.9 179.9,80.6 179.9,82.3 180.5,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7691_",
    className: "st9",
    points: "180.5,83 179.9,82.3 178.1,82.3 177.5,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7690_",
    className: "st10",
    points: "177.5,82.9 178.1,82.3 178.1,80.6 177.5,79.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7689_",
    className: "st11",
    points: "177.5,79.9 178.1,80.6 179.9,80.6 180.5,79.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7688_",
    x: 181.3,
    y: 2.3,
    className: "st7",
    width: 4.5,
    height: 36.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7687_",
    x: 182.6,
    y: 3.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7686_",
    className: "st8",
    points: "185,3 184.4,3.7 184.4,5.4 185,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7685_",
    className: "st9",
    points: "185,6 184.4,5.4 182.6,5.4 182,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7684_",
    className: "st10",
    points: "182,6 182.6,5.4 182.6,3.7 182,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7682_",
    x: 182.6,
    y: 8.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7681_",
    className: "st8",
    points: "185,7.5 184.4,8.2 184.4,9.9 185,10.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7680_",
    className: "st9",
    points: "185,10.6 184.4,9.9 182.6,9.9 182,10.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7679_",
    className: "st10",
    points: "182,10.6 182.6,9.9 182.6,8.2 182,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7678_",
    className: "st11",
    points: "182,7.5 182.6,8.2 184.4,8.2 185,7.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7677_",
    x: 182.6,
    y: 12.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7676_",
    className: "st8",
    points: "185,12.1 184.4,12.7 184.4,14.5 185,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7675_",
    className: "st9",
    points: "185,15.1 184.4,14.5 182.6,14.5 182,15.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7674_",
    className: "st10",
    points: "182,15.1 182.6,14.4 182.6,12.7 182,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7673_",
    className: "st11",
    points: "182,12.1 182.6,12.7 184.4,12.7 185,12.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7672_",
    x: 182.6,
    y: 17.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7671_",
    className: "st8",
    points: "185,16.6 184.4,17.2 184.4,19 185,19.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7670_",
    className: "st9",
    points: "185,19.6 184.4,19 182.6,19 182,19.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7669_",
    className: "st10",
    points: "182,19.6 182.6,19 182.6,17.2 182,16.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7668_",
    className: "st11",
    points: "182,16.6 182.6,17.2 184.4,17.2 185,16.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7667_",
    x: 182.6,
    y: 21.7,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7666_",
    className: "st8",
    points: "185,21.1 184.4,21.7 184.4,23.5 185,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7665_",
    className: "st9",
    points: "185,24.1 184.4,23.5 182.6,23.5 182,24.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7664_",
    className: "st10",
    points: "182,24.1 182.6,23.5 182.6,21.7 182,21.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7663_",
    className: "st11",
    points: "182,21.1 182.6,21.7 184.4,21.7 185,21.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7662_",
    x: 182.6,
    y: 26.3,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7661_",
    className: "st8",
    points: "185,25.6 184.4,26.3 184.4,28 185,28.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7660_",
    className: "st9",
    points: "185,28.7 184.4,28 182.6,28 182,28.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7659_",
    className: "st10",
    points: "182,28.7 182.6,28 182.6,26.3 182,25.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7658_",
    className: "st11",
    points: "182,25.6 182.6,26.3 184.4,26.3 185,25.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7657_",
    x: 182.6,
    y: 30.8,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7656_",
    className: "st8",
    points: "185,30.2 184.4,30.8 184.4,32.5 185,33.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7655_",
    className: "st9",
    points: "185,33.2 184.4,32.5 182.6,32.5 182,33.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7654_",
    className: "st10",
    points: "182,33.2 182.6,32.5 182.6,30.8 182,30.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7653_",
    className: "st11",
    points: "182,30.2 182.6,30.8 184.4,30.8 185,30.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7652_",
    x: 182.6,
    y: 35.3,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7651_",
    className: "st8",
    points: "185,34.7 184.4,35.3 184.4,37.1 185,37.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7650_",
    className: "st9",
    points: "185,37.7 184.4,37.1 182.6,37.1 182,37.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7649_",
    className: "st10",
    points: "182,37.7 182.6,37.1 182.6,35.3 182,34.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7648_",
    className: "st11",
    points: "182,34.7 182.6,35.3 184.4,35.3 185,34.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7647_",
    x: 181.3,
    y: 38.5,
    className: "st7",
    width: 4.5,
    height: 45.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7646_",
    x: 182.6,
    y: 39.8,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7645_",
    className: "st8",
    points: "185,39.2 184.4,39.8 184.4,41.6 185,42.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7644_",
    className: "st9",
    points: "185,42.2 184.4,41.6 182.6,41.6 182,42.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7643_",
    className: "st10",
    points: "182,42.2 182.6,41.6 182.6,39.8 182,39.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7642_",
    className: "st11",
    points: "182,39.2 182.6,39.8 184.4,39.8 185,39.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7641_",
    x: 182.6,
    y: 44.4,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7640_",
    className: "st8",
    points: "185,43.7 184.4,44.4 184.4,46.1 185,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7639_",
    className: "st9",
    points: "185,46.8 184.4,46.1 182.6,46.1 182,46.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7638_",
    className: "st10",
    points: "182,46.8 182.6,46.1 182.6,44.4 182,43.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7637_",
    className: "st11",
    points: "182,43.7 182.6,44.4 184.4,44.4 185,43.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7636_",
    x: 182.6,
    y: 48.9,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7635_",
    className: "st8",
    points: "185,48.2 184.4,48.9 184.4,50.6 185,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7634_",
    className: "st9",
    points: "185,51.3 184.4,50.6 182.6,50.6 182,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7633_",
    className: "st10",
    points: "182,51.3 182.6,50.6 182.6,48.9 182,48.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7632_",
    className: "st11",
    points: "182,48.2 182.6,48.9 184.4,48.9 185,48.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7631_",
    x: 182.6,
    y: 53.4,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7630_",
    className: "st8",
    points: "185,52.8 184.4,53.4 184.4,55.2 185,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7629_",
    className: "st9",
    points: "185,55.8 184.4,55.2 182.6,55.2 182,55.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7628_",
    className: "st10",
    points: "182,55.8 182.6,55.2 182.6,53.4 182,52.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7627_",
    className: "st11",
    points: "182,52.8 182.6,53.4 184.4,53.4 185,52.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7626_",
    x: 182.6,
    y: 57.9,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7625_",
    className: "st8",
    points: "185,57.3 184.4,57.9 184.4,59.7 185,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7624_",
    className: "st9",
    points: "185,60.3 184.4,59.7 182.6,59.7 182,60.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7623_",
    className: "st10",
    points: "182,60.3 182.6,59.7 182.6,57.9 182,57.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7622_",
    className: "st11",
    points: "182,57.3 182.6,57.9 184.4,57.9 185,57.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7621_",
    x: 182.6,
    y: 62.5,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7620_",
    className: "st8",
    points: "185,61.8 184.4,62.5 184.4,64.2 185,64.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7619_",
    className: "st9",
    points: "185,64.9 184.4,64.2 182.6,64.2 182,64.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7618_",
    className: "st10",
    points: "182,64.9 182.6,64.2 182.6,62.5 182,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7617_",
    className: "st11",
    points: "182,61.8 182.6,62.5 184.4,62.5 185,61.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7616_",
    x: 182.6,
    y: 67,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7615_",
    className: "st8",
    points: "185,66.3 184.4,67 184.4,68.7 185,69.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7605_",
    className: "st9",
    points: "185,69.4 184.4,68.7 182.6,68.7 182,69.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7604_",
    className: "st10",
    points: "182,69.4 182.6,68.7 182.6,67 182,66.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7603_",
    className: "st11",
    points: "182,66.3 182.6,67 184.4,67 185,66.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7602_",
    x: 182.6,
    y: 71.5,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7601_",
    className: "st8",
    points: "185,70.9 184.4,71.5 184.4,73.3 185,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7600_",
    className: "st9",
    points: "185,73.9 184.4,73.3 182.6,73.3 182,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7599_",
    className: "st10",
    points: "182,73.9 182.6,73.3 182.6,71.5 182,70.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7598_",
    className: "st11",
    points: "182,70.9 182.6,71.5 184.4,71.5 185,70.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7597_",
    x: 182.6,
    y: 76,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7596_",
    className: "st8",
    points: "185,75.4 184.4,76 184.4,77.8 185,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7595_",
    className: "st9",
    points: "185,78.4 184.4,77.8 182.6,77.8 182,78.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7594_",
    className: "st10",
    points: "182,78.4 182.6,77.8 182.6,76 182,75.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7593_",
    className: "st11",
    points: "182,75.4 182.6,76 184.4,76 185,75.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7592_",
    x: 182.6,
    y: 80.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7591_",
    className: "st8",
    points: "185,79.9 184.4,80.6 184.4,82.3 185,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7590_",
    className: "st9",
    points: "185,83 184.4,82.3 182.6,82.3 182,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_7589_",
    className: "st10",
    points: "182,82.9 182.6,82.3 182.6,80.6 182,79.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1110_",
    className: "st11",
    points: "182,79.9 182.6,80.6 184.4,80.6 185,79.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1061_",
    x: 46,
    y: 84.2,
    className: "st24",
    width: 1.1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1060_",
    x: 46,
    y: 67.6,
    className: "st24",
    width: 1.1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1059_",
    x: 46.9,
    y: 84.2,
    className: "st25",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1058_",
    x: 46.9,
    y: 67.6,
    className: "st25",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1057_",
    x: 46,
    y: 84.2,
    className: "st13",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1056_",
    x: 46,
    y: 67.6,
    className: "st13",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1055_",
    className: "st26",
    d: "M38.6,71.8v11.3c0,0.7,0.5,1.2,1.2,1.2h13.4c0.7,0,1.2-0.5,1.2-1.2V71.8l-3.3-3.3H48h-3.1 h-3L38.6,71.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1054_",
    className: "st27",
    cx: 46.5,
    cy: 76.4,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1053_",
    className: "st3",
    d: "M38.6,71.8v11.3c0,0.7,0.5,1.2,1.2,1.2h13.4c0.7,0,1.2-0.5,1.2-1.2v-2.4v-8.9l-3.3-3.3H48 h-3.1h-3L38.6,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1052_",
    d: "M50.9,68.5l3.3,3.3v8.9v2.4c0,0.7-0.5,1.2-1.2,1.2h0.2c0.7,0,1.2-0.5,1.2-1.2v-2.4v-8.9l-3.3-3.3H50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1051_",
    className: "st28",
    d: "M40,84.2c-0.7,0-1.2-0.5-1.2-1.2V71.8l3.3-3.3h-0.2l-3.3,3.3v11.3c0,0.7,0.5,1.2,1.2,1.2H40 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1050_",
    className: "st29",
    d: "M54.1,76.4c0,1.6-0.5,3.1-1.4,4.3c-1.4,1.9-3.6,3.1-6.1,3.1c-2.5,0-4.7-1.2-6.1-3.1 c-0.9-1.2-1.4-2.7-1.4-4.3c0-4.1,3.3-7.5,7.5-7.5C50.7,68.9,54.1,72.3,54.1,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1049_",
    d: "M46.5,83.8c2.5,0,4.7-1.2,6.1-3.1H40.4C41.8,82.6,44,83.8,46.5,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1048_",
    className: "st30",
    d: "M46.7,68.9c-4.1,0-7.5,3.3-7.5,7.5c0,1.6,0.5,3.1,1.4,4.3c1.4,1.9,3.6,3.1,6.1,3.1h-0.2 c-2.5,0-4.7-1.2-6.1-3.1C39.6,79.5,39,78,39,76.4c0-4.1,3.3-7.5,7.5-7.5H46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1047_",
    className: "st31",
    d: "M46.3,83.8c2.5,0,4.7-1.2,6.1-3.1h0.2c-1.4,1.9-3.6,3.1-6.1,3.1H46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1046_",
    className: "st32",
    d: "M52.4,80.7c0.9-1.2,1.4-2.7,1.4-4.3c0-4.1-3.3-7.5-7.5-7.5h0.2c4.1,0,7.5,3.3,7.5,7.5 c0,1.6-0.5,3.1-1.4,4.3H52.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1045_",
    x: 63.3,
    y: 84.2,
    className: "st24",
    width: 1.1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1044_",
    x: 63.3,
    y: 67.6,
    className: "st24",
    width: 1.1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1043_",
    x: 64.2,
    y: 84.2,
    className: "st25",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1042_",
    x: 64.2,
    y: 67.6,
    className: "st25",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1041_",
    x: 63.3,
    y: 84.2,
    className: "st13",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1040_",
    x: 63.3,
    y: 67.6,
    className: "st13",
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1039_",
    className: "st26",
    d: "M55.9,71.8v11.3c0,0.7,0.5,1.2,1.2,1.2h13.4c0.7,0,1.2-0.5,1.2-1.2V71.8l-3.3-3.3h-3.1h-3.1 h-3L55.9,71.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1038_",
    className: "st27",
    cx: 63.8,
    cy: 76.4,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    className: "st3",
    d: "M55.9,71.8v11.3c0,0.7,0.5,1.2,1.2,1.2h13.4c0.7,0,1.2-0.5,1.2-1.2v-2.4v-8.9l-3.3-3.3h-3.1 h-3.1h-3L55.9,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1036_",
    d: "M68.2,68.5l3.3,3.3v8.9v2.4c0,0.7-0.5,1.2-1.2,1.2h0.2c0.7,0,1.2-0.5,1.2-1.2v-2.4v-8.9l-3.3-3.3H68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1035_",
    className: "st28",
    d: "M57.3,84.2c-0.7,0-1.2-0.5-1.2-1.2V71.8l3.3-3.3h-0.2l-3.3,3.3v11.3c0,0.7,0.5,1.2,1.2,1.2 H57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1034_",
    className: "st29",
    d: "M71.4,76.4c0,1.6-0.5,3.1-1.4,4.3c-1.4,1.9-3.6,3.1-6.1,3.1c-2.5,0-4.7-1.2-6.1-3.1 c-0.9-1.2-1.4-2.7-1.4-4.3c0-4.1,3.3-7.5,7.5-7.5C68,68.9,71.4,72.3,71.4,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1033_",
    d: "M63.8,83.8c2.5,0,4.7-1.2,6.1-3.1H57.7C59.1,82.6,61.3,83.8,63.8,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1032_",
    className: "st30",
    d: "M64,68.9c-4.1,0-7.5,3.3-7.5,7.5c0,1.6,0.5,3.1,1.4,4.3c1.4,1.9,3.6,3.1,6.1,3.1h-0.2 c-2.5,0-4.7-1.2-6.1-3.1c-0.9-1.2-1.4-2.7-1.4-4.3c0-4.1,3.3-7.5,7.5-7.5H64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1031_",
    className: "st31",
    d: "M63.6,83.8c2.5,0,4.7-1.2,6.1-3.1h0.2c-1.4,1.9-3.6,3.1-6.1,3.1H63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1030_",
    className: "st32",
    d: "M69.7,80.7c0.9-1.2,1.4-2.7,1.4-4.3c0-4.1-3.3-7.5-7.5-7.5h0.2c4.1,0,7.5,3.3,7.5,7.5 c0,1.6-0.5,3.1-1.4,4.3H69.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1029_",
    x: 59.1,
    y: 88.2,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1028_",
    x: 60.5,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1027_",
    className: "st8",
    points: "59.8,89 60.5,89.6 62.2,89.6 62.9,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1026_",
    className: "st9",
    points: "62.9,89 62.2,89.6 62.2,91.4 62.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1025_",
    className: "st10",
    points: "62.9,92 62.2,91.4 60.5,91.4 59.8,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1024_",
    className: "st11",
    points: "59.8,92 60.5,91.4 60.5,89.6 59.8,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1023_",
    x: 65,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1022_",
    className: "st8",
    points: "64.4,89 65,89.6 66.8,89.6 67.4,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1021_",
    className: "st9",
    points: "67.4,89 66.8,89.6 66.8,91.4 67.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1020_",
    className: "st10",
    points: "67.4,92 66.8,91.4 65,91.4 64.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1019_",
    className: "st11",
    points: "64.4,92 65,91.4 65,89.6 64.4,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1018_",
    x: 69.5,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1017_",
    className: "st8",
    points: "68.9,89 69.5,89.6 71.3,89.6 71.9,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1016_",
    className: "st9",
    points: "71.9,89 71.3,89.6 71.3,91.4 71.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1015_",
    className: "st10",
    points: "71.9,92 71.3,91.4 69.5,91.4 68.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1014_",
    className: "st11",
    points: "68.9,92 69.5,91.4 69.5,89.6 68.9,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1013_",
    x: 74.1,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1012_",
    className: "st8",
    points: "73.4,89 74.1,89.6 75.8,89.6 76.5,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1011_",
    className: "st9",
    points: "76.5,89 75.8,89.6 75.8,91.4 76.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1010_",
    className: "st10",
    points: "76.5,92 75.8,91.4 74.1,91.4 73.4,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1009_",
    className: "st11",
    points: "73.4,92 74.1,91.4 74.1,89.6 73.4,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1008_",
    x: 78.6,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1007_",
    className: "st8",
    points: "77.9,89 78.6,89.6 80.3,89.6 81,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1006_",
    className: "st9",
    points: "81,89 80.3,89.6 80.3,91.4 81,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1005_",
    className: "st10",
    points: "81,92 80.3,91.4 78.6,91.4 77.9,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1004_",
    className: "st11",
    points: "77.9,92 78.6,91.4 78.6,89.6 77.9,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1003_",
    x: 83.1,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1002_",
    className: "st8",
    points: "82.5,89 83.1,89.6 84.9,89.6 85.5,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1001_",
    className: "st9",
    points: "85.5,89 84.9,89.6 84.9,91.4 85.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1000_",
    className: "st10",
    points: "85.5,92 84.9,91.4 83.1,91.4 82.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_999_",
    className: "st11",
    points: "82.5,92 83.1,91.4 83.1,89.6 82.5,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_998_",
    x: 87.6,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_997_",
    className: "st8",
    points: "87,89 87.6,89.6 89.4,89.6 90,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_996_",
    className: "st9",
    points: "90,89 89.4,89.6 89.4,91.4 90,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_995_",
    className: "st10",
    points: "90,92 89.4,91.4 87.6,91.4 87,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_994_",
    className: "st11",
    points: "87,92 87.6,91.4 87.6,89.6 87,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_993_",
    x: 92.2,
    y: 89.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_992_",
    className: "st8",
    points: "91.5,89 92.2,89.6 93.9,89.6 94.5,89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_991_",
    className: "st9",
    points: "94.5,89 93.9,89.6 93.9,91.4 94.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_990_",
    className: "st10",
    points: "94.5,92 93.9,91.4 92.2,91.4 91.5,92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_989_",
    className: "st11",
    points: "91.5,92 92.2,91.4 92.2,89.6 91.5,89  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_988_",
    x: 90.8,
    y: 2.3,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_987_",
    x: 123.8,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_986_",
    className: "st8",
    points: "126.2,6 125.6,5.4 123.8,5.4 123.2,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_985_",
    className: "st9",
    points: "123.2,6 123.8,5.4 123.8,3.6 123.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_984_",
    className: "st10",
    points: "123.2,3 123.8,3.6 125.6,3.6 126.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_983_",
    className: "st11",
    points: "126.2,3 125.6,3.6 125.6,5.4 126.2,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_982_",
    x: 119.3,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_981_",
    className: "st8",
    points: "121.7,6 121.1,5.4 119.3,5.4 118.7,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_980_",
    className: "st9",
    points: "118.7,6 119.3,5.4 119.3,3.6 118.7,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_979_",
    className: "st10",
    points: "118.7,3 119.3,3.6 121.1,3.6 121.7,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_978_",
    className: "st11",
    points: "121.7,3 121.1,3.6 121.1,5.4 121.7,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_977_",
    x: 114.8,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_976_",
    className: "st8",
    points: "117.2,6 116.5,5.4 114.8,5.4 114.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_975_",
    className: "st9",
    points: "114.1,6 114.8,5.4 114.8,3.6 114.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_974_",
    className: "st10",
    points: "114.1,3 114.8,3.6 116.5,3.6 117.2,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_973_",
    className: "st11",
    points: "117.2,3 116.5,3.6 116.5,5.4 117.2,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_972_",
    x: 110.3,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_971_",
    className: "st8",
    points: "112.7,6 112,5.4 110.3,5.4 109.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_970_",
    className: "st9",
    points: "109.6,6 110.3,5.4 110.3,3.6 109.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_969_",
    className: "st10",
    points: "109.6,3 110.3,3.6 112,3.6 112.7,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_968_",
    className: "st11",
    points: "112.7,3 112,3.6 112,5.4 112.7,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_967_",
    x: 105.7,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_966_",
    className: "st8",
    points: "108.1,6 107.5,5.4 105.7,5.4 105.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_965_",
    className: "st9",
    points: "105.1,6 105.7,5.4 105.7,3.6 105.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_964_",
    className: "st10",
    points: "105.1,3 105.7,3.6 107.5,3.6 108.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_963_",
    className: "st11",
    points: "108.1,3 107.5,3.6 107.5,5.4 108.1,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_962_",
    x: 101.2,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_961_",
    className: "st8",
    points: "103.6,6 103,5.4 101.2,5.4 100.6,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_960_",
    className: "st9",
    points: "100.6,6 101.2,5.4 101.2,3.6 100.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_959_",
    className: "st10",
    points: "100.6,3 101.2,3.6 103,3.6 103.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_958_",
    className: "st11",
    points: "103.6,3 103,3.6 103,5.4 103.6,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_957_",
    x: 96.7,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_956_",
    className: "st8",
    points: "99.1,6 98.4,5.4 96.7,5.4 96.1,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_955_",
    className: "st9",
    points: "96.1,6 96.7,5.4 96.7,3.6 96.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_954_",
    className: "st10",
    points: "96.1,3 96.7,3.6 98.4,3.6 99.1,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_953_",
    className: "st11",
    points: "99.1,3 98.4,3.6 98.4,5.4 99.1,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_952_",
    x: 92.2,
    y: 3.6,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_951_",
    className: "st8",
    points: "94.6,6 93.9,5.4 92.2,5.4 91.5,6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_950_",
    className: "st9",
    points: "91.5,6 92.2,5.4 92.2,3.6 91.5,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_949_",
    className: "st10",
    points: "91.5,3 92.2,3.6 93.9,3.6 94.6,3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_948_",
    className: "st11",
    points: "94.6,3 93.9,3.6 93.9,5.4 94.6,6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_899_",
    x: 11.2,
    y: 73.7,
    className: "st33",
    width: 20.7,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_898_",
    x: 11.6,
    y: 74,
    className: "st34",
    width: 20.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_897_",
    x: 11.6,
    y: 75.1,
    className: "st35",
    width: 20.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_895_",
    x: 10.9,
    y: 83.6,
    className: "st36",
    width: 20.7,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_894_",
    x: 31.5,
    y: 73.7,
    className: "st32",
    width: 0.4,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_893_",
    x: 30.1,
    y: 73.7,
    className: "st37",
    width: 0.2,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_892_",
    x: 12.6,
    y: 73.7,
    className: "st38",
    width: 0.8,
    height: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_891_",
    className: "st38",
    d: "M12.8,76.4v9.5h8.4c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.7-4.7-4.7L12.8,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_888_",
    className: "st39",
    d: "M12.8,76.3l8.4,0c2.7,0,4.8,2.2,4.8,4.8c0,2.7-2.2,4.8-4.8,4.8h-8.4h-0.1v-0.1L12.8,76.3 L12.8,76.3L12.8,76.3z M12.8,76.4v9.5h-0.1v-0.1h8.4c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.7-4.7-4.7v-0.1l0,0.1L12.8,76.4L12.8,76.4 L12.8,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_887_",
    className: "st33",
    d: "M12.8,76.4v9.5h8.4c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.7-4.7-4.7L12.8,76.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_886_",
    x: 8.4,
    y: 73.1,
    className: "st33",
    width: 4.8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_885_",
    x: 31.9,
    y: 79.3,
    className: "st40",
    width: 1.1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_884_",
    x: 31.9,
    y: 77.6,
    className: "st34",
    width: 0.6,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_883_",
    x: 8.8,
    y: 73.4,
    className: "st34",
    width: 3.9,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_881_",
    className: "st12",
    d: "M16,39.9h-1.9v-1.3v-1.3l1.9,0h1.2v2c0,0.3-0.3,0.6-0.6,0.6C16.7,39.9,16,39.9,16,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_880_",
    className: "st41",
    d: "M16.8,39.9v-2.6h0.5c0,0,0,1.9,0,2.1C17.3,39.7,16.9,39.9,16.8,39.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_879_",
    x: 0.4,
    y: 16.9,
    className: "st42",
    width: 23,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_878_",
    x: 23.5,
    y: 16.9,
    className: "st12",
    width: 4.8,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_877_",
    x: 0.4,
    y: 16.9,
    className: "st43",
    width: 27.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_876_",
    x: 0.4,
    y: 36.1,
    className: "st32",
    width: 27.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    className: "st42",
    d: "M16,14.4h-1.9v1.3v1.3H16h1.2v-2c0-0.3-0.3-0.6-0.6-0.6H16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_874_",
    className: "st29",
    d: "M16.8,14.4v2.6h0.5c0,0,0-1.9,0-2.1C17.3,14.6,16.9,14.4,16.8,14.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_873_",
    className: "st24",
    points: "152.8,26.3 152.6,26.3 152.6,21.1 152.8,21.1 152.8,17.2 142.8,17.2 142.8,30.2  152.8,30.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_872_",
    className: "st24",
    points: "141.2,21.1 141.4,21.1 141.4,26.3 141.2,26.3 141.2,30.2 151.1,30.2 151.1,17.2  141.2,17.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_871_",
    className: "st44",
    cx: 147,
    cy: 23.7,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_870_",
    className: "st32",
    d: "M146.8,20.5c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2h0.2c-1.8,0-3.2-1.4-3.2-3.2 c0-1.8,1.4-3.2,3.2-3.2H146.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_869_",
    className: "st45",
    cx: 147,
    cy: 23.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_868_",
    className: "st45",
    cx: 147.1,
    cy: 23.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_867_",
    className: "st25",
    d: "M150.1,23.6c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1v0.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_866_",
    className: "st13",
    d: "M143.9,23.6c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1v0.1c0,1.7-1.4,3.1-3.1,3.1 c-1.7,0-3.1-1.4-3.1-3.1V23.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_865_",
    x: 152.6,
    y: 26.3,
    className: "st13",
    width: 0.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_864_",
    x: 152.6,
    y: 17.2,
    className: "st13",
    width: 0.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_863_",
    x: 152.4,
    y: 21.1,
    className: "st13",
    width: 0.2,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_862_",
    x: 141.2,
    y: 26.3,
    className: "st32",
    width: 0.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_861_",
    x: 141.2,
    y: 17.2,
    className: "st32",
    width: 0.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_860_",
    x: 141.4,
    y: 21.1,
    className: "st32",
    width: 0.2,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_859_",
    x: 150.1,
    y: 15.4,
    className: "st29",
    width: 1.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_858_",
    x: 142.4,
    y: 15.4,
    className: "st29",
    width: 1.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_857_",
    x: 145.9,
    y: 30.1,
    className: "st29",
    width: 2.1,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_856_",
    x: 150.1,
    y: 30.1,
    className: "st29",
    width: 1.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_855_",
    x: 142.4,
    y: 30.1,
    className: "st29",
    width: 1.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_851_",
    x: 150.1,
    y: 15.4,
    className: "st32",
    width: 1.4,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_850_",
    x: 142.4,
    y: 15.4,
    className: "st32",
    width: 1.4,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_849_",
    x: 150.1,
    y: 16.9,
    className: "st32",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_848_",
    x: 142.4,
    y: 16.9,
    className: "st32",
    width: 1.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    className: "st2",
    d: "M113.3,45.3v-1.9h0.3l0.3,0.5l0.3-0.5h0.3v1.9c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1.6l-0.3,0.4v0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.1 l-0.3-0.4v1.6c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0C113.4,45.4,113.4,45.4,113.3,45.3C113.3,45.4,113.3,45.3,113.3,45.3z M111.4,43.7 v-0.4h1.3v0.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.1h-0.3v1.7c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1.7h-0.3v0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0C111.5,43.9,111.5,43.8,111.4,43.7 C111.4,43.8,111.4,43.8,111.4,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    className: "st2",
    d: "M113.3,45.3C113.3,45.3,113.3,45.4,113.3,45.3c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1v-1.6v0l0,0l0.3,0.4l0,0v0v0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1v-0.1v0l0,0 l0.3-0.4l0,0v0v1.6c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0s0-0.1,0-0.1v-1.9h0v0h-0.3v0l0,0l-0.3,0.5l0,0l0,0l-0.3-0.5 l0,0v0h-0.3v0h0V45.3z M113.3,45.3v-1.9v0h0h0.3h0l0,0l0.3,0.5l0,0l0,0l0.3-0.5l0,0h0h0.3h0v0v1.9c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1.6h0l0,0l-0.3,0.4l0,0h0v0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1 v-0.1h0l0,0l-0.3-0.4l0,0h0v1.6c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C113.3,45.4,113.3,45.3,113.3,45.3z M111.4,43.7 C111.4,43.7,111.4,43.8,111.4,43.7c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0s0-0.1,0-0.1v-0.1v0h0h0.3h0v0v1.7c0,0,0,0.1,0,0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1v-1.7v0h0h0.3h0v0v0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1v-0.4h0v0h-1.3v0h0V43.7z M111.4,43.7v-0.4v0h0h1.3h0v0v0.4c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1v-0.1h0v0h-0.3v0h0v1.7c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1.7h0v0h-0.3v0h0v0.1 c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C111.4,43.8,111.4,43.8,111.4,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_801_",
    className: "st2",
    d: "M93.4,51.3c1-1.1,1.8-2.1,2.7-3c3.6-3.2,7.6-4.4,12.2-2.4c4.3,1.8,6.7,6.3,5.7,11 c-0.9,4.3-5,7.5-9.4,7.7c-4.1,0.1-7.3-1.7-9.8-4.7c-0.4-0.5-0.8-0.9-1.3-1.6c-0.4,0.4-0.6,0.7-0.9,1.1c-2.8,3.5-6.2,5.5-10.9,5.2 c-4.5-0.3-8.7-4.5-9-9c-0.4-5.7,4-10.5,10.1-10.5c4,0,7.2,2,9.6,5.2C92.8,50.5,93,50.8,93.4,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    className: "st0",
    d: "M83.4,48.1c-4.2,0-7.3,2.7-7.6,6.2c-0.3,3.1,2.1,6.2,5.5,6.9c3.3,0.7,6-0.7,8-3.1 c3.1-3.7,3-3,0-6.7C87.7,49.4,85.5,48.2,83.4,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    className: "st0",
    d: "M104.2,48.1c-0.5,0-0.9,0-1.2,0.1c-3.6,0.7-5.8,3.1-7.5,6.1c-0.1,0.2-0.1,0.7,0,0.9 c1.5,2.6,3.4,4.9,6.4,5.8c2.9,0.9,5.5,0.2,7.5-2.1c1.8-2,2.2-4.4,1-6.9C109.1,49.5,106.9,48.3,104.2,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    className: "st2",
    d: "M86.4,55.5c0,0.1-0.1,0.2-0.2,0.2h-6.2c-0.1,0-0.2-0.1-0.2-0.2v-1.9c0-0.1,0.1-0.2,0.2-0.2 h6.2c0.1,0,0.2,0.1,0.2,0.2V55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_789_",
    className: "st2",
    d: "M106.9,53.6c0-0.1-0.1-0.2-0.2-0.2h-1.8c-0.1,0-0.2-0.1-0.2-0.2v-1.8c0-0.1-0.1-0.2-0.2-0.2 h-1.9c-0.1,0-0.2,0.1-0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.8c-0.1,0-0.2,0.1-0.2,0.2v1.9c0,0.1,0.1,0.2,0.2,0.2h1.8 c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1,0.1,0.2,0.2,0.2h1.9c0.1,0,0.2-0.1,0.2-0.2v-1.8c0-0.1,0.1-0.2,0.2-0.2h1.8 c0.1,0,0.2-0.1,0.2-0.2V53.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_788_",
    className: "st46",
    cx: 132.7,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_787_",
    className: "st46",
    cx: 131,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_786_",
    className: "st46",
    cx: 129.3,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_785_",
    className: "st46",
    cx: 127.6,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_784_",
    className: "st46",
    cx: 125.7,
    cy: 63.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_783_",
    className: "st46",
    cx: 124.1,
    cy: 63.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_754_",
    className: "st46",
    cx: 122.6,
    cy: 62.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_560_",
    className: "st46",
    cx: 121.2,
    cy: 61.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_559_",
    className: "st46",
    cx: 120.1,
    cy: 60.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_558_",
    className: "st46",
    cx: 119.1,
    cy: 59.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_557_",
    className: "st46",
    cx: 118.4,
    cy: 57.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_556_",
    className: "st46",
    cx: 118,
    cy: 56.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_555_",
    className: "st46",
    cx: 117.8,
    cy: 54.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    className: "st2",
    d: "M118.1,52.3c0.4,0,0.6,0.4,0.6,0.7c0,0.4-0.4,0.6-0.7,0.6c-0.4,0-0.6-0.4-0.6-0.8 C117.4,52.5,117.7,52.2,118.1,52.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_553_",
    className: "st2",
    cx: 118.5,
    cy: 51.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_552_",
    className: "st46",
    cx: 119.2,
    cy: 49.9,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_551_",
    className: "st46",
    cx: 120.2,
    cy: 48.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_550_",
    className: "st46",
    cx: 121.4,
    cy: 47.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_549_",
    className: "st46",
    cx: 122.8,
    cy: 46.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_548_",
    className: "st46",
    cx: 124.3,
    cy: 46.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_547_",
    className: "st46",
    cx: 125.9,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_546_",
    className: "st46",
    cx: 127.6,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_542_",
    className: "st46",
    cx: 132.7,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_541_",
    className: "st46",
    cx: 131,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_540_",
    className: "st46",
    cx: 129.3,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_539_",
    className: "st46",
    cx: 127.6,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_538_",
    className: "st46",
    cx: 156.5,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_537_",
    className: "st46",
    cx: 154.8,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_536_",
    className: "st46",
    cx: 153.1,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_535_",
    className: "st46",
    cx: 151.4,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_534_",
    className: "st46",
    cx: 149.7,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_533_",
    className: "st46",
    cx: 148,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_532_",
    className: "st46",
    cx: 146.3,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_531_",
    className: "st46",
    cx: 144.6,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_530_",
    className: "st46",
    cx: 142.9,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_529_",
    className: "st46",
    cx: 141.2,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_526_",
    className: "st46",
    cx: 139.5,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_521_",
    className: "st46",
    cx: 137.8,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_520_",
    className: "st46",
    cx: 136.1,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_519_",
    className: "st46",
    cx: 134.4,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_518_",
    className: "st46",
    cx: 156.5,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_517_",
    className: "st46",
    cx: 158.2,
    cy: 63.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_516_",
    className: "st46",
    cx: 159.7,
    cy: 62.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_514_",
    className: "st46",
    cx: 161.1,
    cy: 61.9,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_513_",
    className: "st46",
    cx: 162.3,
    cy: 60.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_512_",
    className: "st46",
    cx: 163.3,
    cy: 59.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_511_",
    className: "st46",
    cx: 164,
    cy: 57.9,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_510_",
    className: "st46",
    cx: 164.4,
    cy: 56.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_509_",
    className: "st46",
    cx: 164.6,
    cy: 54.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_508_",
    className: "st46",
    cx: 164.4,
    cy: 53.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_507_",
    className: "st46",
    cx: 164,
    cy: 51.5,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_506_",
    className: "st46",
    cx: 163.2,
    cy: 50,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_505_",
    className: "st46",
    cx: 162.2,
    cy: 48.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_504_",
    className: "st46",
    cx: 161,
    cy: 47.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_503_",
    className: "st46",
    cx: 159.6,
    cy: 46.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_502_",
    className: "st46",
    cx: 158.1,
    cy: 46.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_501_",
    className: "st46",
    cx: 156.4,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_500_",
    className: "st46",
    cx: 154.8,
    cy: 45.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_499_",
    className: "st46",
    cx: 156.5,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_498_",
    className: "st46",
    cx: 154.8,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_497_",
    className: "st46",
    cx: 153.1,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_496_",
    className: "st46",
    cx: 151.4,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_495_",
    className: "st46",
    cx: 149.7,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_494_",
    className: "st46",
    cx: 148,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_476_",
    className: "st46",
    cx: 146.3,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_475_",
    className: "st46",
    cx: 144.6,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_474_",
    className: "st46",
    cx: 142.9,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_351_",
    className: "st46",
    cx: 141.2,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_350_",
    className: "st46",
    cx: 139.5,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_347_",
    className: "st46",
    cx: 137.8,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_346_",
    className: "st46",
    cx: 136.1,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_345_",
    className: "st46",
    cx: 134.4,
    cy: 63.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_335_",
    className: "st2",
    d: "M162.7,69.9h1.1v-2.1h-1.1V69.9z M162.3,69.9v-2.1c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h1.1 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v2.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-1.1c-0.1,0-0.2,0-0.3-0.1 S162.3,70,162.3,69.9z M160.1,69.9h1.1v-0.6h-1.1V69.9z M159.7,70.1v-2.4c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h0.2 c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1V69h1.2c0.1,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.1v0.9c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.4c-0.1,0-0.1,0-0.1-0.1C159.7,70.2,159.7,70.2,159.7,70.1z  M157.1,70c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0l0.3,0.1h0.9v-0.9h-1.1v-1.6h1.3c0.1,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-0.9v0.9h0.7c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v0.9 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.8c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.1-0.1 C157.1,70.1,157.1,70.1,157.1,70z M154.5,70.3v-1.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h1.1v-0.9h-1.2 c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.2c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.3v0.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-1.1v0.9h1.2c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1H154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st2",
    d: "M162.6,69.9v-2.1v0h0h1.1h0v0v2.1v0h0L162.6,69.9L162.6,69.9L162.6,69.9z M162.7,69.9h1.1v0h0 v-2.1h0v0h-1.1v0h0L162.7,69.9L162.7,69.9L162.7,69.9z M162.3,69.9c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h1.1 c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-2.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1h-1.1c-0.1,0-0.2,0-0.2,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2V69.9z M162.3,69.9v-2.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h1.1c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.3v2.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-1.1c-0.1,0-0.2,0-0.3-0.1 C162.3,70.1,162.3,70,162.3,69.9z M160,69.9v-0.6v0h0h1.1h0v0v0.6v0h0L160,69.9L160,69.9L160,69.9z M160.1,69.9h1.1v0h0v-0.6h0v0 h-1.1v0h0L160.1,69.9L160.1,69.9L160.1,69.9z M159.7,70.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0h1.4c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1 v-0.9c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0h-1.2h0v0v-1.2v0h0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0h-0.2 c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1V70.1z M159.7,70.1v-2.4c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h0.2c0.1,0,0.1,0,0.1,0.1 c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1v0h0V69h0v0h1.2c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1v0.9 c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-1.4c-0.1,0-0.1,0-0.1-0.1C159.7,70.2,159.7,70.2,159.7,70.1z M157.1,70 c0,0.1,0,0.1,0.1,0.2h0l0,0c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0h0.8c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.1,0.1-0.2v-0.9c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1h-0.7h0v0v-0.9v0h0h0.9c0,0,0.1,0,0.1,0 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0h-1.3v0h0v1.6h0v0h1.1h0v0v0.9v0h0h-0.9h0l0,0l-0.3-0.1l0,0l0,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0S157.1,69.9,157.1,70z M157.1,70c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0l0,0l0,0l0.3,0.1l0,0v0 h0.9v0h0v-0.9h0v0h-1.1h0v0v-1.6v0h0h1.3c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-0.9v0 h0v0.9h0v0h0.7c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v0.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-0.8 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.1-0.1l0,0l0,0C157.1,70.1,157.1,70.1,157.1,70z M154.5,70.3 h1.6c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0h-1.2h0v0v-0.9v0h0h1.1c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.1,0.1-0.2v-0.9c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1h-1.2c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0h1.2h0v0v0.9v0h0h-1.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2L154.5,70.3L154.5,70.3 L154.5,70.3z M154.5,70.3v-1.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h1.1v0h0v-0.9h0v0h-1.2c-0.1,0-0.1,0-0.1-0.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1h1.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v0.9 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-1.1v0h0v0.9h0v0h1.2c0.1,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1 c0,0-0.1,0.1-0.1,0.1L154.5,70.3L154.5,70.3L154.5,70.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArduinoMegaIllustration);
export default __webpack_public_path__ + "static/media/icon-arduino-mega-illustration.750419a4ba1c59de72a70a760daccdd2.svg";
export { ForwardRef as ReactComponent };